export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Please input your username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Please input your password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  // 404 page
  'pages.404.title': '404',
  // info page
  'pages.info.title': 'Page Under Development',
  'pages.info.subTitle': 'This feature is under development, please stay tuned...',
  'pages.info.buttonText': 'Back Home',
  // Admin page
  'pages.admin.addMorePages': 'Want to add more pages? Please refer to',
  'pages.admin.useBlock': 'use block',
  // Login page (supplement)
  'pages.login.title': 'Welcome Back',
  'pages.login.subtitle': "Don't have an account?",
  'pages.login.getStarted': 'Contact Admin',
  'pages.login.needHelp': 'Need Help?',
  'pages.login.welcome': 'Safety Energy Guard',
  'pages.login.welcomeSubtitle': 'Focus on electrical safety and electrical fire risk monitoring across terminals, circuits, and key loads.',
  'pages.login.moltenSaltInfo': 'This platform supports electrical fire risk identification, hazard alerts, and continuous terminal operation monitoring.',
  'pages.login.username.label': 'Username',
  'pages.login.password.label': 'Password',
  // Workplace page
  'pages.workplace.title': 'Workplace',
  'pages.workplace.description': 'Monitor task statuses in real-time and quickly create data import tasks',
  'pages.workplace.dataImportApproval': 'Data Import Approval',
  'pages.workplace.dataProcessingPipeline': 'Data Processing Pipeline',
  'pages.workplace.workflowTask': 'Workflow Task',
  'pages.workplace.dataUploadTask': 'Data Upload Task',
  'pages.workplace.anomalyDetectionTask': 'Anomaly Detection Task',
  'pages.workplace.performancePredictionTask': 'Performance Prediction Task',
  'pages.workplace.modelTrainingTask': 'Model Training Task',
  'pages.workplace.modelTestingTask': 'Model Testing Task',
  'pages.workplace.quickCreate': 'Quick Create',
  'pages.workplace.status.pending': 'Pending',
  'pages.workplace.status.approving': 'Approving',
  'pages.workplace.status.completed': 'Completed',
  'pages.workplace.status.queued': 'Queued',
  'pages.workplace.status.running': 'Running',
  'pages.workplace.status.processing': 'Processing',
  'pages.workplace.status.training': 'Training',
  'pages.workplace.status.testing': 'Testing',
  'pages.workplace.status.failed': 'Failed',
  'pages.workplace.experimentDataImport': 'Experiment Data Import',
  'pages.workplace.simulationDataImport': 'Simulation Data Import',
  // Task Manager
  'pages.taskManager.taskSubmit': 'Task Submit',
  'pages.taskManager.taskMonitor': 'Task Monitor',
  'pages.taskManager.resultDownload': 'Result Download',
  'pages.taskManager.resultDownload.taskName': 'Task Name',
  'pages.taskManager.resultDownload.taskType': 'Task Type',
  'pages.taskManager.resultDownload.queryFailed': 'Query Failed',
  'pages.taskManager.resultDownload.queryFailedRetry': 'Query failed, please try again',
  'pages.taskManager.resultDownload.taskTypeLabel': 'Task Type',
  'pages.taskManager.resultDownload.completedTime': 'Completed Time',
  'pages.taskManager.resultDownload.dataPoints': 'Data Points',
  'pages.taskManager.resultDownload.modelAccuracy': 'Model Accuracy',
  'pages.taskManager.resultDownload.saltSystem': 'Salt System',
  'pages.taskManager.resultDownload.correlation': 'Correlation',
  'pages.taskManager.resultDownload.optimizationGoal': 'Optimization Goal',
  'pages.taskManager.resultDownload.optimalComposition': 'Optimal Composition',
  'pages.taskManager.resultDownload.unnamedTask': 'Unnamed Task',
  'pages.taskManager.resultDownload.startDownloadPng': 'Starting PNG download',
  'pages.taskManager.resultDownload.startDownloadExcel': 'Starting Excel download',
  'pages.taskManager.resultDownload.viewChart': 'View Chart',
  'pages.taskManager.resultDownload.downloadResult': 'Download Result',
  'pages.taskManager.resultDownload.downloadData': 'Download Data',
  'pages.taskManager.resultDownload.downloadReport': 'Download Report',
  'pages.taskManager.resultDownload.totalRecords': 'Total {total} records',
  'pages.taskManager.resultDownload.noData': 'No Data',
  'pages.taskManager.resultDownload.dataStorageManagement': 'Data Storage Management',
  'pages.taskManager.resultDownload.dataStorageDescription': 'Store analysis results directly into data warehouse and knowledge base, supporting subsequent queries and reuse',
  'pages.taskManager.resultDownload.selectTargetDatabase': 'Select Target Database',
  'pages.taskManager.resultDownload.saveToDatabase': 'Save to Database',
  'pages.taskManager.resultDownload.linkToKnowledgeGraph': 'Link to Knowledge Graph',
  'pages.taskManager.resultDownload.card.taskType': 'Task Type',
  'pages.taskManager.resultDownload.card.completedTime': 'Completed Time',
  'pages.taskManager.resultDownload.card.dataPoints': 'Data Points',
  'pages.taskManager.resultDownload.card.modelAccuracy': 'Model Accuracy',
  'pages.taskManager.resultDownload.card.saltSystem': 'Salt System',
  'pages.taskManager.resultDownload.card.correlation': 'Correlation',
  'pages.taskManager.resultDownload.card.optimizationGoal': 'Optimization Goal',
  'pages.taskManager.resultDownload.card.optimalComposition': 'Optimal Composition',
  // Task List
  'pages.taskList.getTaskListFailed': 'Failed to get task list',
  'pages.taskList.getTaskListFailedRetry': 'Failed to get task list, please try again',
  'pages.taskList.taskIdNotExists': 'Task ID does not exist',
  'pages.taskList.confirmPause': 'Confirm Pause',
  'pages.taskList.confirmPauseContent': 'Are you sure you want to pause task "{taskName}"?',
  'pages.taskList.pauseSuccess': 'Task paused successfully',
  'pages.taskList.pauseFailed': 'Failed to pause task',
  'pages.taskList.pauseFailedRetry': 'Failed to pause task, please try again',
  'pages.taskList.confirmCancel': 'Confirm Cancel',
  'pages.taskList.confirmCancelContent': 'Are you sure you want to cancel task "{taskName}"?',
  'pages.taskList.cancelSuccess': 'Task cancelled successfully',
  'pages.taskList.cancelFailed': 'Failed to cancel task',
  'pages.taskList.cancelFailedRetry': 'Failed to cancel task, please try again',
  'pages.taskList.retrySuccess': 'Task retried successfully',
  'pages.taskList.retryFailed': 'Failed to retry task',
  'pages.taskList.retryFailedRetry': 'Failed to retry task, please try again',
  'pages.taskList.statusQueued': 'Queued',
  'pages.taskList.statusRunning': 'Running',
  'pages.taskList.statusCompleted': 'Completed',
  'pages.taskList.statusFailed': 'Failed',
  'pages.taskList.statusCancelled': 'Cancelled',
  'pages.taskList.statusUnknown': 'Unknown',
  'pages.taskList.downloadExcelSuccess': 'Excel downloaded successfully',
  'pages.taskList.downloadExcelFailed': 'Failed to download Excel',
  'pages.taskList.downloadPngSuccess': 'PNG downloaded successfully',
  'pages.taskList.downloadPngFailed': 'Failed to download PNG',
  // Experiment Calculate
  'pages.experimentCalculate.workflowOverview': 'Workflow Overview',
  'pages.experimentCalculate.workflowExample': 'Workflow Example',
  'pages.experimentCalculate.startWorkflow': 'Start Workflow',
  'pages.experimentCalculate.workflowGoal': 'Workflow Goal',
  'pages.experimentCalculate.workflowOverviewText': 'Establish a closed-loop workflow between experiments and simulations to achieve data-driven material design and optimization.',
  'pages.experimentCalculate.goal1': 'Experimental data drives simulation parameter optimization',
  'pages.experimentCalculate.goal2': 'Simulation data complements extreme conditions difficult to measure in experiments',
  'pages.experimentCalculate.goal3': 'Form a complete closed loop of verification-prediction-optimization',
  'pages.experimentCalculate.goal4': 'Accelerate new material development and performance optimization',
  'pages.experimentCalculate.viewDetailedGoals': 'View Detailed Goals',
  'pages.experimentCalculate.workflowDiagram': 'Workflow Diagram',
  'pages.experimentCalculate.step1Title': 'Experimental Data',
  'pages.experimentCalculate.step1Desc': 'Upload experimental data',
  'pages.experimentCalculate.step2Title': 'Simulation Calculation',
  'pages.experimentCalculate.step2Desc': 'Run simulation model',
  'pages.experimentCalculate.step3Title': 'Verification & Optimization',
  'pages.experimentCalculate.step3Desc': 'Data comparison and correction',
  'pages.experimentCalculate.step4Title': 'Performance Prediction',
  'pages.experimentCalculate.step4Desc': 'New material design optimization',
  'pages.experimentCalculate.clickStepsForDetails': '💡 Click each step to view detailed process',
  'pages.experimentCalculate.experimentDataDrivenSimulation': 'Experiment Data Driven Simulation',
  // Task List Details Modal
  'pages.taskList.details.title': 'Task Details',
  'pages.taskList.details.getTaskDetailFailed': 'Failed to get task details',
  'pages.taskList.details.getTaskDetailFailedRetry': 'Failed to get task details, please try again',
  'pages.taskList.details.taskInfo': 'Task Information',
  'pages.taskList.details.taskId': 'Task ID',
  'pages.taskList.details.submitTime': 'Submit Time',
  'pages.taskList.details.taskType': 'Task Type',
  'pages.taskList.details.taskStatus': 'Task Status',
  'pages.taskList.details.analysisParams': 'Analysis Parameters',
  'pages.taskList.details.saltSystem': 'Salt System',
  'pages.taskList.details.temperatureRange': 'Temperature Range',
  'pages.taskList.details.fittingModel': 'Fitting Model',
  'pages.taskList.details.dataPoints': 'Data Points',
  'pages.taskList.details.realtimeLogs': 'Realtime Logs',
  'pages.taskList.details.noLogs': 'No Logs',
  'pages.taskList.details.previewResult': 'Preview Result',
  'pages.experimentCalculate.viscosityDataDriven': 'Viscosity Data Driven',
  'pages.experimentCalculate.viscosityDataDrivenDesc': 'Upload experimental viscosity data (η-T), the system automatically generates MD input parameters, verifies and supplements diffusion coefficient (D-T) and thermal conductivity (λ-T)',
  'pages.experimentCalculate.uploadViscosityData': 'Upload experimental viscosity data',
  'pages.experimentCalculate.generateMdParams': 'System generates MD input parameters',
  'pages.experimentCalculate.verifyAndSupplement': 'Verify and supplement D(T), λ(T)',
  'pages.experimentCalculate.experimentalVerificationWorkflow': 'Experimental Verification Workflow',
  'pages.experimentCalculate.experimentalVerificationWorkflowDesc': 'Verify the accuracy of calculation models through experimental data and generate verification reports',
  'pages.experimentCalculate.startThisWorkflow': 'Start This Workflow',
  'pages.experimentCalculate.workflowA': 'Workflow A: Experimental Verification',
  'pages.experimentCalculate.workflowB': 'Workflow B: Performance Optimization',
  'pages.experimentCalculate.workflowC': 'Workflow C: Corrosion Assessment',
  'pages.experimentCalculate.input': 'Input',
  'pages.experimentCalculate.output': 'Output',
  'pages.experimentCalculate.systemProcess': 'System Process',
  'pages.experimentCalculate.workflowAProcess': 'Data Cleaning → Arrhenius Fitting → Database/Simulation Comparison → Auto Generate Verification Report',
  'pages.experimentCalculate.workflowBProcess': 'Call Database → ML Predict Candidate Formulation → Generate Recommended Salt System',
  'pages.experimentCalculate.workflowCProcess': 'Call Electrochemical/Corrosion Model → Predict Ni/Cr Dissolution Rate → Generate Material Compatibility Report',
  'pages.experimentCalculate.autoGenerateReport': 'Auto Generate Verification Report',
  'pages.experimentCalculate.targetPerformance': 'Target Performance Cp≥2J/g·K',
  'pages.experimentCalculate.recommendedSaltSystem': 'Recommended Salt System',
  'pages.experimentCalculate.saltComponentImpurityLevel': 'Salt Component + Impurity Level',
  'pages.experimentCalculate.materialCompatibilityReport': 'Material Compatibility Report',
  'pages.experimentCalculate.workflowBDetail': 'Workflow B: Performance Optimization Details',
  'pages.experimentCalculate.workflowCDetail': 'Workflow C: Corrosion Assessment Details',
  'pages.experimentCalculate.workflowB.title': 'Performance Optimization Workflow',
  'pages.experimentCalculate.workflowB.description': 'Based on target performance requirements, predict and recommend optimal material formulations through machine learning.',
  'pages.experimentCalculate.workflowB.input1': 'Target Performance Indicators (Cp≥2J/g·K, η≤3mPa·s)',
  'pages.experimentCalculate.workflowB.input2': 'Material Composition Database',
  'pages.experimentCalculate.workflowB.input3': 'Historical Performance Data',
  'pages.experimentCalculate.workflowB.output1': 'Candidate Material Recommendations',
  'pages.experimentCalculate.workflowB.output2': 'Performance Prediction Results',
  'pages.experimentCalculate.workflowB.output3': 'Optimization Recommendation Report',
  'pages.experimentCalculate.workflowB.step1': 'Requirement Analysis',
  'pages.experimentCalculate.workflowB.step1Desc': 'Parse target performance requirements',
  'pages.experimentCalculate.workflowB.step2': 'Data Filtering',
  'pages.experimentCalculate.workflowB.step2Desc': 'Filter candidate materials that meet the criteria from the database',
  'pages.experimentCalculate.workflowB.step3': 'Machine Learning Prediction',
  'pages.experimentCalculate.workflowB.step3Desc': 'Use trained models to predict candidate material performance',
  'pages.experimentCalculate.workflowB.step4': 'Result Ranking',
  'pages.experimentCalculate.workflowB.step4Desc': 'Rank candidate materials based on prediction results',
  'pages.experimentCalculate.workflowB.step5': 'Generate Recommendations',
  'pages.experimentCalculate.workflowB.step5Desc': 'Output optimal material formulation and performance prediction',
  'pages.experimentCalculate.workflowC.title': 'Corrosion Assessment Workflow',
  'pages.experimentCalculate.workflowC.description': 'Assess the corrosiveness of molten salt on structural materials and generate material compatibility reports.',
  'pages.experimentCalculate.workflowC.input1': 'Salt Composition and Impurity Level',
  'pages.experimentCalculate.workflowC.input2': 'Structural Material Information',
  'pages.experimentCalculate.workflowC.input3': 'Operating Conditions (Temperature, Time)',
  'pages.experimentCalculate.workflowC.output1': 'Corrosion Rate Prediction',
  'pages.experimentCalculate.workflowC.output2': 'Material Compatibility Assessment',
  'pages.experimentCalculate.workflowC.output3': 'Protection Measures Recommendations',
  'pages.experimentCalculate.workflowC.step1': 'Parameter Input',
  'pages.experimentCalculate.workflowC.step1Desc': 'Input salt composition, impurities, and material information',
  'pages.experimentCalculate.workflowC.step2': 'Model Calculation',
  'pages.experimentCalculate.workflowC.step2Desc': 'Call electrochemical/corrosion models to calculate corrosion rate',
  'pages.experimentCalculate.workflowC.step3': 'Risk Assessment',
  'pages.experimentCalculate.workflowC.step3Desc': 'Assess material compatibility based on calculation results',
  'pages.experimentCalculate.workflowC.step4': 'Generate Report',
  'pages.experimentCalculate.workflowC.step4Desc': 'Output detailed corrosion assessment report',
  // Experiment Calculate Steps
  'pages.experimentCalculate.step1.title': 'Step 1: Experimental Data',
  'pages.experimentCalculate.step1.subtitle': 'Experimental Data Collection and Preprocessing',
  'pages.experimentCalculate.step1.description': 'Collect molten salt property data from various experimental instruments and perform standardized preprocessing to ensure data quality and consistency.',
  'pages.experimentCalculate.step1.supportedDataTypes': 'Supported Experimental Data Types',
  'pages.experimentCalculate.step1.dataProcessingFlow': 'Data Processing Flow',
  'pages.experimentCalculate.step1.processingStep1': 'Data Collection',
  'pages.experimentCalculate.step1.processingDesc1': 'Obtain raw data from experimental instruments',
  'pages.experimentCalculate.step1.processingStep2': 'Data Cleaning',
  'pages.experimentCalculate.step1.processingDesc2': 'Remove outliers and noise',
  'pages.experimentCalculate.step1.processingStep3': 'Format Standardization',
  'pages.experimentCalculate.step1.processingDesc3': 'Unify data format and units',
  'pages.experimentCalculate.step1.processingStep4': 'Data Validation',
  'pages.experimentCalculate.step1.processingDesc4': 'Check data integrity and accuracy',
  'pages.experimentCalculate.step1.viscosityData': 'Viscosity Data',
  'pages.experimentCalculate.step1.viscosityRelation': 'η-T relation',
  'pages.experimentCalculate.step1.densityData': 'Density Data',
  'pages.experimentCalculate.step1.densityRelation': 'ρ-T relation',
  'pages.experimentCalculate.step1.specificHeatData': 'Specific Heat Data',
  'pages.experimentCalculate.step1.specificHeatRelation': 'Cp-T relation',
  'pages.experimentCalculate.step1.thermalConductivityData': 'Thermal Conductivity Data',
  'pages.experimentCalculate.step1.thermalConductivityRelation': 'λ-T relation',
  'pages.experimentCalculate.step1.electricalConductivityData': 'Electrical Conductivity Data',
  'pages.experimentCalculate.step1.electricalConductivityRelation': 'σ-T relation',
  'pages.experimentCalculate.step2.title': 'Step 2: Simulation Calculation',
  'pages.experimentCalculate.step2.subtitle': 'Multiscale Simulation Calculation',
  'pages.experimentCalculate.step2.description': 'Use various calculation methods from atomic scale to macroscopic scale to comprehensively simulate and predict molten salt property behavior.',
  'pages.experimentCalculate.step2.supportedTools': 'Supported Tools:',
  'pages.experimentCalculate.step2.mdTitle': 'Molecular Dynamics (MD)',
  'pages.experimentCalculate.step2.mdDesc': 'Simulate molten salt microstructure and transport properties',
  'pages.experimentCalculate.step2.dftTitle': 'Density Functional Theory (DFT)',
  'pages.experimentCalculate.step2.dftDesc': 'Calculate electronic structure and thermodynamic properties',
  'pages.experimentCalculate.step2.calphadTitle': 'CALPHAD Method',
  'pages.experimentCalculate.step2.calphadDesc': 'Calculate phase diagrams and thermodynamic properties',
  'pages.experimentCalculate.step2.toolLammps': 'LAMMPS',
  'pages.experimentCalculate.step2.toolGromacs': 'GROMACS',
  'pages.experimentCalculate.step2.toolCustom': 'Custom Force Field',
  'pages.experimentCalculate.step2.toolVasp': 'VASP',
  'pages.experimentCalculate.step2.toolQe': 'Quantum ESPRESSO',
  'pages.experimentCalculate.step2.toolCastep': 'CASTEP',
  'pages.experimentCalculate.step2.toolThermoCalc': 'Thermo-Calc',
  'pages.experimentCalculate.step2.toolFactSage': 'FactSage',
  'pages.experimentCalculate.step2.toolPandat': 'Pandat',
  'pages.experimentCalculate.step3.title': 'Step 3: Verification & Optimization',
  'pages.experimentCalculate.step3.subtitle': 'Data Verification and Model Optimization',
  'pages.experimentCalculate.step3.description': 'Compare experimental data with simulation results, improve calculation model accuracy and reliability through systematic analysis and optimization processes.',
  'pages.experimentCalculate.step4.title': 'Step 4: Performance Prediction',
  'pages.experimentCalculate.step4.subtitle': 'New Material Performance Prediction and Optimization',
  'pages.experimentCalculate.step4.description': 'Predict new material performance based on verified models, conduct material design through intelligent optimization algorithms, and accelerate new material development.',
  'pages.experimentCalculate.step4.coreFeatures': 'Core Features:',
  'pages.experimentCalculate.step4.dataComparisonAnalysis': 'Data Comparison Analysis',
  'pages.experimentCalculate.step4.dataComparisonDesc': 'Comparison analysis between experimental data and simulation results',
  'pages.experimentCalculate.step4.modelOptimization': 'Model Parameter Optimization',
  'pages.experimentCalculate.step4.modelOptimizationDesc': 'Optimize simulation model parameters based on experimental data',
  'pages.experimentCalculate.step4.reportGeneration': 'Verification Report Generation',
  'pages.experimentCalculate.step4.reportGenerationDesc': 'Generate detailed verification reports',
  'pages.experimentCalculate.step4.feature1': 'Error Analysis',
  'pages.experimentCalculate.step4.feature2': 'Consistency Assessment',
  'pages.experimentCalculate.step4.feature3': 'Trend Validation',
  'pages.experimentCalculate.step4.feature4': 'Sensitivity Analysis',
  'pages.experimentCalculate.step4.feature5': 'Parameter Tuning',
  'pages.experimentCalculate.step4.feature6': 'Model Validation',
  'pages.experimentCalculate.step4.feature7': 'Data Comparison Charts',
  'pages.experimentCalculate.step4.feature8': 'Model Accuracy Assessment',
  'pages.experimentCalculate.step4.feature9': 'Optimization Suggestions',
  'pages.experimentCalculate.step5.performancePrediction': 'Performance Prediction',
  'pages.experimentCalculate.step5.performancePredictionDesc': 'Predict new material performance based on verified models',
  'pages.experimentCalculate.step5.optimizationDesign': 'Optimization Design',
  'pages.experimentCalculate.step5.optimizationDesignDesc': 'Optimize material design based on target performance',
  'pages.experimentCalculate.step5.designReport': 'Design Report',
  'pages.experimentCalculate.step5.designReportDesc': 'Generate new material design reports',
  'pages.experimentCalculate.step5.feature1': 'Property Prediction',
  'pages.experimentCalculate.step5.feature2': 'Performance Assessment',
  'pages.experimentCalculate.step5.feature3': 'Trend Analysis',
  'pages.experimentCalculate.step5.feature4': 'Multi-objective Optimization',
  'pages.experimentCalculate.step5.feature5': 'Constraint Handling',
  'pages.experimentCalculate.step5.feature6': 'Optimal Solution Search',
  'pages.experimentCalculate.step5.feature7': 'Performance Prediction Results',
  'pages.experimentCalculate.step5.feature8': 'Optimization Design Solutions',
  'pages.experimentCalculate.step5.feature9': 'Implementation Suggestions',
  // Data Import
  'pages.dataImport.batchImport': 'Batch Import',
  'pages.dataImport.add': 'Add',
  'pages.dataImport.importRecord': 'Import Record',
  'pages.dataImport.midDataImport': 'Mid Data Import',
  // Third Import
  'pages.thirdImport.syncSuccess': 'Sync Success',
  'pages.thirdImport.syncFailed': 'Sync Failed',
  'pages.thirdImport.noSyncTime': 'None',
  'pages.thirdImport.featureDeveloping': 'Feature Under Development',
  'pages.thirdImport.latestSync': 'Latest Sync',
  'pages.thirdImport.dataVolume': 'Data Volume',
  'pages.thirdImport.noInfo': 'No Information',
  'pages.thirdImport.syncCompleted': 'Sync Completed',
  'pages.thirdImport.syncing': 'Syncing',
  'pages.thirdImport.unknownStatus': 'Unknown Status',
  // Data Filter
  'pages.dataFilter.system': 'System',
  'pages.dataFilter.physicalType': 'Physical Type',
  'pages.dataFilter.tempUnit': 'Temperature Unit',
  'pages.dataFilter.molComponentRatio': 'MOL Component Ratio',
  'pages.dataFilter.physicalUnit': 'Physical Unit',
  'pages.dataFilter.dataSource': 'Data Source',
  'pages.dataFilter.operation': 'Operation',
  'pages.dataFilter.details': 'Details',
  'pages.dataFilter.simulationList': 'Simulation Calculation List',
  'pages.dataFilter.conditionFilterList': 'Condition Filter List',
  'pages.dataFilter.selected': 'Selected',
  'pages.dataFilter.items': 'items',
  'pages.dataFilter.clearSelection': 'Clear Selection',
  'pages.dataFilter.exportData': 'Export Data',
  'pages.dataFilter.downloadData': 'Download Data',
  'pages.dataFilter.cannotGetRecordId': 'Cannot get record ID or data source',
  'pages.dataFilter.tempRange': 'Temperature Range',
  'pages.dataFilter.minTemp': 'Minimum Temperature',
  'pages.dataFilter.maxTemp': 'Maximum Temperature',
  'pages.dataFilter.maxTempMustGreaterThanMin': 'Maximum temperature must be greater than minimum temperature',
  'pages.dataFilter.compoundBaseDataInfo': 'Compound Basic Data Information',
  'pages.dataFilter.index': 'Index',
  'pages.dataFilter.component': 'Component',
  'pages.dataFilter.coefficient': 'Coefficient',
  'pages.dataFilter.getDetailFailed': 'Failed to get details',
  'pages.dataFilter.missingParams': 'Missing required parameters',
  'pages.dataFilter.detail': 'Detail',
  'pages.dataFilter.physicalData': 'Physical Data',
  'pages.dataFilter.importTime': 'Import Time',
  'pages.dataFilter.createTime': 'Create Time',
  'pages.dataFilter.materialBaseData': 'Material Base Data',
  'pages.dataFilter.materialName': 'Material Name',
  'pages.dataFilter.meltingPoint': 'Melting Point',
  'pages.dataFilter.boilingPoint': 'Boiling Point',
  'pages.dataFilter.thermalStabilityMin': 'Thermal Stability Min',
  'pages.dataFilter.thermalStabilityMax': 'Thermal Stability Max',
  'pages.dataFilter.thermalStabilityWidth': 'Thermal Stability Width',
  'pages.dataFilter.reductionPotential': 'Reduction Potential',
  'pages.dataFilter.oxidationPotential': 'Oxidation Potential',
  'pages.dataFilter.corrosionPotential': 'Corrosion Potential',
  'pages.dataFilter.corrosive': 'Corrosive',
  'pages.dataFilter.electrochemistryMin': 'Electrochemistry Min',
  'pages.dataFilter.electrochemistryMax': 'Electrochemistry Max',
  'pages.dataFilter.factorData': 'Factor Data',
  // Material Properties
  'pages.materialProperties.compoundBasicInfo': 'Compound Basic Data Information',
  'pages.materialProperties.system': 'System',
  'pages.materialProperties.physicalType': 'Physical Type',
  'pages.materialProperties.dataSource': 'Data Source',
  'pages.materialProperties.physicalUnit': 'Physical Unit',
  'pages.materialProperties.tempMin': 'Temperature Min',
  'pages.materialProperties.tempMax': 'Temperature Max',
  'pages.materialProperties.meltingPoint': 'Melting Point',
  'pages.materialProperties.boilingPoint': 'Boiling Point',
  'pages.materialProperties.thermalStabilityWidth': 'Thermal Stability Width',
  'pages.materialProperties.corrosivity': 'Corrosivity',
  'pages.materialProperties.corrosionPotential': 'Corrosion Potential',
  'pages.materialProperties.serialNumber': 'Serial Number',
  'pages.materialProperties.component': 'Component',
  'pages.materialProperties.coefficient': 'Coefficient',
  'pages.materialProperties.createTime': 'Create Time',
  'pages.materialProperties.details': 'Details',
  'pages.materialProperties.tempUnit': 'Temperature Unit',
  'pages.materialProperties.index': 'Index',
  'pages.materialProperties.measuredValue': 'Measured Value',
  'pages.materialProperties.temperature': 'Temperature',
  'pages.materialProperties.unitConversion': 'Unit Conversion',
  'pages.materialProperties.convert': 'Convert',
  'pages.materialProperties.compoundBaseDataInfo': 'Compound Base Data Information',
  // Unit Conversion
  'pages.unitConversion.loadUnitsFailed': 'Failed to load unit list',
  'pages.unitConversion.invalidTargetUnit': 'Invalid target unit',
  'pages.unitConversion.convertSuccess': 'Conversion successful',
  'pages.unitConversion.convertFailed': 'Conversion failed, please try again later',
  'pages.unitConversion.title': 'Unit Conversion',
  'pages.unitConversion.cancel': 'Cancel',
  'pages.unitConversion.convert': 'Convert',
  'pages.unitConversion.measuredValue': 'Measured Value',
  'pages.unitConversion.measuredValueRequired': 'Please enter measured value',
  'pages.unitConversion.measuredValuePlaceholder': 'Please enter measured value',
  'pages.unitConversion.physicalType': 'Physical Type',
  'pages.unitConversion.physicalTypePlaceholder': 'Physical Type',
  'pages.unitConversion.originalUnit': 'Original Physical Unit',
  'pages.unitConversion.originalUnitPlaceholder': 'Original Physical Unit',
  'pages.unitConversion.targetUnit': 'Target Physical Unit',
  'pages.unitConversion.targetUnitRequired': 'Please select target physical unit',
  'pages.unitConversion.targetUnitPlaceholder': 'Please select target physical unit',
  'pages.unitConversion.result': 'Conversion Result',
  // Experiment Result
  'pages.experimentResult.experimentData': 'Physical Property Test Data',
  'pages.experimentResult.system': 'System',
  'pages.experimentResult.physicalType': 'Physical Type',
  'pages.experimentResult.physicalUnit': 'Physical Unit',
  'pages.experimentResult.dataSource': 'Data Source',
  'pages.experimentResult.tempUnit': 'Temperature Unit',
  'pages.experimentResult.index': 'Index',
  'pages.experimentResult.component': 'Component',
  'pages.experimentResult.measuredValue': 'Measured Value',
  'pages.experimentResult.temperature': 'Temperature',
  'pages.experimentResult.coefficient': 'Coefficient',
  // Statistics Analysis
  'pages.statisticsAnalysis.system': 'System',
  'pages.statisticsAnalysis.physicalType': 'Physical Type',
  'pages.statisticsAnalysis.dataSource': 'Data Source',
  'pages.statisticsAnalysis.temperatureRange': 'Temperature Range',
  'pages.statisticsAnalysis.systemRequired': 'System is required, please enter system',
  'pages.statisticsAnalysis.physicalTypeRequired': 'Physical type is required, please select physical type first',
  // Data Flow
  'pages.dataFlow.all': 'All',
  'pages.dataFlow.taskNo': 'Task No',
  'pages.dataFlow.taskName': 'Task Name',
  'pages.dataFlow.dataSourceType': 'Data Source Type',
  'pages.dataFlow.dataSource': 'Data Source',
  'pages.dataFlow.fileFormat': 'File Format',
  'pages.dataFlow.taskStatus': 'Task Status',
  'pages.dataFlow.totalProgress': 'Total Progress',
  'pages.dataFlow.totalRecords': 'Total Records',
  'pages.dataFlow.createTime': 'Create Time',
  'pages.dataFlow.operation': 'Operation',
  'pages.dataFlow.viewDetails': 'View Details',
  'pages.dataFlow.status.pending': 'Pending',
  'pages.dataFlow.status.extracting': 'Extracting',
  'pages.dataFlow.status.transforming': 'Transforming',
  'pages.dataFlow.status.loading': 'Loading',
  'pages.dataFlow.status.completed': 'Completed',
  'pages.dataFlow.status.failed': 'Failed',
  // Home
  'pages.home.getStatisticsFailed': 'Failed to get statistics',
  'pages.home.getStatisticsFailedRetry': 'Failed to get statistics, please try again later',
  'pages.home.materialCount': 'Material Count',
  'pages.home.experimentRecord': 'Experiment Record',
  'pages.home.modelCount': 'Model Count',
  'pages.home.month.january': 'January',
  'pages.home.month.february': 'February',
  'pages.home.month.march': 'March',
  'pages.home.month.april': 'April',
  'pages.home.month.may': 'May',
  'pages.home.month.june': 'June',
  // Chart Generate
  'pages.chartGenerate.success': 'Chart generated successfully',
  'pages.chartGenerate.failed': 'Chart generation failed',
  'pages.chartGenerate.queryFailed': 'Query failed, please try again later',
  'pages.chartGenerate.generateChartFirst': 'Please generate chart first',
  'pages.chartGenerate.generatingImages': 'Generating chart images...',
  'pages.chartGenerate.uploadingToServer': 'Uploading to server...',
  'pages.chartGenerate.downloadingPDF': 'Downloading PDF file...',
  'pages.chartGenerate.imageGenerationFailed': 'Chart image generation failed',
  'pages.chartGenerate.exportSuccess': 'PDF export successful',
  'pages.chartGenerate.exportFailed': 'PDF export failed',
  'pages.chartGenerate.lineChart': 'Line Chart',
  'pages.chartGenerate.barChart': 'Bar Chart',
  'pages.chartGenerate.scatterChart': 'Scatter Chart',
  'pages.chartGenerate.chartType': 'Chart Type',
  'pages.chartGenerate.pleaseSelectChartType': 'Please select chart type',
  'pages.chartGenerate.physicalType': 'Physical Type',
  'pages.chartGenerate.pleaseSelectPhysicalType': 'Please select physical type',
  'pages.chartGenerate.temperature': 'Temperature',
  'pages.chartGenerate.minTemp': 'Minimum Temperature',
  'pages.chartGenerate.maxTemp': 'Maximum Temperature',
  'pages.chartGenerate.maxTempMustGreaterThanMin': 'Maximum temperature must be greater than minimum temperature',
  'pages.chartGenerate.system': 'System',
  'pages.chartGenerate.pleaseInputSystem': 'Please input system',
  'pages.chartGenerate.generateChart': 'Generate Chart',
  'pages.chartGenerate.reset': 'Reset',
  // Data Export
  'pages.dataExport.invalidImageData': 'Invalid chart image data format',
  'pages.dataExport.noResponse': 'Export API no response',
  'pages.dataExport.exportFailed': 'Export API returned failed status',
  'pages.dataExport.experimentData': 'Experiment Data',
  'pages.dataExport.literatureData': 'Literature Data',
  'pages.dataExport.simulationData': 'Simulation Data',
  // Performance Candidate
  'pages.performanceCandidate.loadTempUnitsFailed': 'Failed to load temperature units',
  'pages.performanceCandidate.reverseCompleted': 'Reverse recommendation completed!',
  'pages.performanceCandidate.reverseFailed': 'Reverse recommendation failed, please try again',
  'pages.performanceCandidate.formReset': 'Form has been reset',
  'pages.performanceCandidate.saltComponent': 'Salt Component',
  'pages.performanceCandidate.minMolarRatio': 'Minimum Molar Ratio (mol%)',
  'pages.performanceCandidate.maxMolarRatio': 'Maximum Molar Ratio (mol%)',
  'pages.performanceCandidate.recommendedMolarRatio': 'Recommended Molar Ratio (mol%)',
  'pages.performanceCandidate.candidateCombination': 'Candidate Combination {index}',
  'pages.performanceCandidate.matchScore': 'Match Score',
  'pages.performanceCandidate.predictedPerformance': 'Predicted Performance Index',
  'pages.performanceCandidate.molarRatioRange': 'Molar Ratio Range',
  'pages.performanceCandidate.otherProperties': 'Other Physical Properties',
  'pages.performanceCandidate.unknown': 'Unknown',
  'pages.performanceCandidate.recommendationReason': 'Recommendation Reason',
  'pages.performanceCandidate.physicalPropType': 'Physical Property Type',
  'pages.performanceCandidate.physicalPropType.required': 'Please select physical property type',
  'pages.performanceCandidate.physicalPropType.placeholder': 'Please select physical property type',
  'pages.performanceCandidate.rangeType': 'Performance Index Range Type',
  'pages.performanceCandidate.rangeType.required': 'Please select range type',
  'pages.performanceCandidate.rangeType.placeholder': 'Please select range type',
  'pages.performanceCandidate.minValue': 'Performance Index Minimum Value',
  'pages.performanceCandidate.minValue.required': 'Please enter performance index minimum value',
  'pages.performanceCandidate.minValue.placeholder': 'Please enter minimum value',
  'pages.performanceCandidate.maxValue': 'Performance Index Maximum Value',
  'pages.performanceCandidate.maxValue.required': 'Please enter performance index maximum value',
  'pages.performanceCandidate.maxValue.placeholder': 'Please enter maximum value',
  'pages.performanceCandidate.physicalUnit': 'Performance Index Unit',
  'pages.performanceCandidate.physicalUnit.placeholder': 'e.g.: W/m·K, mPa·s, g/cm³',
  'pages.performanceCandidate.workTempRange': 'Working Temperature Range',
  'pages.performanceCandidate.workTempMin.required': 'Please enter minimum temperature',
  'pages.performanceCandidate.workTempMin.placeholder': 'Minimum Temperature',
  'pages.performanceCandidate.workTempMax.required': 'Please enter maximum temperature',
  'pages.performanceCandidate.workTempMax.placeholder': 'Maximum Temperature',
  'pages.performanceCandidate.tempUnit': 'Temperature Unit',
  'pages.performanceCandidate.tempUnit.placeholder': 'Please select temperature unit',
  'pages.performanceCandidate.algorithmType': 'Algorithm Type',
  'pages.performanceCandidate.algorithmType.placeholder': 'Please select algorithm type',
  'pages.performanceCandidate.recommendCount': 'Number of Candidate Materials',
  'pages.performanceCandidate.positiveInteger': 'Please enter a positive integer',
  'pages.performanceCandidate.integer': 'Please enter an integer',
  'pages.performanceCandidate.recommendCount.placeholder': 'Please enter number of candidate materials',
  'pages.performanceCandidate.matchScore.range': 'Please enter a value between 0-100',
  'pages.performanceCandidate.matchScore.placeholder': 'Please enter minimum match score (0-100)',
  'pages.performanceCandidate.start': 'Start Reverse Recommendation',
  'pages.performanceCandidate.reset': 'Reset',
  'pages.performanceCandidate.reversing': 'Reversing in progress...',
  'pages.performanceCandidate.emptyDescription1': 'Please fill in query conditions on the left and click "Start Reverse Recommendation"',
  'pages.performanceCandidate.emptyDescription2': 'Reverse recommendation results will be displayed here',
  'pages.performanceCandidate.resultTitle': 'Reverse Recommendation Results',
  'pages.performanceCandidate.noResult': 'No reverse recommendation results available',
  // Replace Recommend
  'pages.replaceRecommend.completed': 'Recommendation completed!',
  'pages.replaceRecommend.failed': 'Recommendation failed, please try again',
  'pages.replaceRecommend.formReset': 'Form has been reset',
  'pages.replaceRecommend.candidateSystem': 'Candidate System',
  'pages.replaceRecommend.matchScore': 'Match Score',
  'pages.replaceRecommend.applicationMatch': 'Application Match',
  'pages.replaceRecommend.thermalStability': 'Thermal Stability',
  'pages.replaceRecommend.corrosionCompatibility': 'Corrosion Compatibility',
  'pages.replaceRecommend.properties': 'Properties',
  'pages.replaceRecommend.unknown': 'Unknown',
  'pages.replaceRecommend.recommendationReason': 'Recommendation Reason',
  'pages.replaceRecommend.applicationScenario': 'Target Application Scenario',
  'pages.replaceRecommend.applicationScenario.required': 'Please enter target application scenario',
  'pages.replaceRecommend.maxLength': 'Maximum 500 characters',
  'pages.replaceRecommend.applicationScenario.placeholder': 'e.g.: 900°C thermal energy storage',
  'pages.replaceRecommend.recommendMethod': 'Recommendation Method',
  'pages.replaceRecommend.recommendMethod.placeholder': 'Please select recommendation method',
  'pages.replaceRecommend.recommendCount': 'Number of Candidate Materials',
  'pages.replaceRecommend.positiveInteger': 'Please enter a positive integer',
  'pages.replaceRecommend.integer': 'Please enter an integer',
  'pages.replaceRecommend.recommendCount.placeholder': 'Please enter number of candidate materials',
  'pages.replaceRecommend.matchScore.range': 'Please enter a value between 0-100',
  'pages.replaceRecommend.matchScore.placeholder': 'Please enter minimum match score (0-100)',
  'pages.replaceRecommend.additionalConditions': 'Additional Conditions (Optional)',
  'pages.replaceRecommend.conditionType.required': 'Please select condition type',
  'pages.replaceRecommend.conditionType.placeholder': 'Condition Type',
  'pages.replaceRecommend.conditionDescription.required': 'Please enter condition description',
  'pages.replaceRecommend.conditionDescription.placeholder': 'e.g.: Hastelloy-N corrosion rate < 50 μm/year',
  'pages.replaceRecommend.addCondition': 'Add Condition',
  'pages.replaceRecommend.start': 'Start Recommendation',
  'pages.replaceRecommend.reset': 'Reset',
  'pages.replaceRecommend.recommending': 'Recommending in progress...',
  'pages.replaceRecommend.emptyDescription1': 'Please fill in query conditions on the left and click "Start Recommendation"',
  'pages.replaceRecommend.emptyDescription2': 'Recommendation results will be displayed here',
  'pages.replaceRecommend.resultTitle': 'Recommendation Results',
  'pages.replaceRecommend.noResult': 'No recommendation results available',
  // Dig Result
  'pages.digResult.systemKeywords': 'System Keywords',
  'pages.digResult.all': 'All',
  'pages.digResult.queryFailed': 'Query failed, please try again later',
  'pages.digResult.meltingPoint': 'Melting Point',
  'pages.digResult.physicalProperty': 'Physical Property',
  'pages.digResult.dataSource': 'Data Source',
  'pages.digResult.documentOverview': 'Document Data Overview',
  'pages.digResult.noData': 'No data available, please perform a search',
  'pages.digResult.system': 'System {index}',
  'pages.digResult.systemIncomplete': 'System information is incomplete, unable to view comparative analysis',
  'pages.digResult.viewCompare': 'View Comparative Analysis',
  // Location Manage
  'pages.locationManage.totalLocations': 'Total Locations',
  'pages.locationManage.disabledCount': 'Disabled Count',
  'pages.locationManage.edit': 'Edit',
  'pages.locationManage.entryPort': 'Entry Port',
  'pages.locationManage.exitPort': 'Exit Port',
  // Add Location
  'pages.addLocation.aisleRow': 'Aisle/Row',
  'pages.addLocation.layerColumn': 'Layer/Column',
  'pages.addLocation.next': 'Next',
  'pages.addLocation.cancel': 'Cancel',
  'pages.addLocation.previous': 'Previous',
  'pages.addLocation.save': 'Save',
  // Ship Manage
  'pages.shipManage.creator': 'Creator',
  'pages.shipManage.startEndTime': 'Start/End Time',
  'pages.shipManage.createTime': 'Create Time',
  'pages.shipManage.component1': 'Component 1',
  'pages.shipManage.component2': 'Component 2',
  'pages.shipManage.component3': 'Component 3',
  'pages.shipManage.component4': 'Component 4',
  'pages.shipManage.component5': 'Component 5',
  // Model Train
  'pages.modelTrain.modelTraining': 'Model Training',
  'pages.modelTrain.modelTesting': 'Model Testing',
  // Model Train Tab
  'pages.modelTrain.trainingName': 'Training Name',
  'pages.modelTrain.trainingNameRequired': 'Please enter training name',
  'pages.modelTrain.trainingNamePlaceholder': 'Please enter',
  'pages.modelTrain.selectModel': 'Select Model',
  'pages.modelTrain.selectModelRequired': 'Please select model',
  'pages.modelTrain.selectModelPlaceholder': 'Please select model',
  'pages.modelTrain.selectVersion': 'Select Version',
  'pages.modelTrain.selectVersionRequired': 'Please select version',
  'pages.modelTrain.selectVersionPlaceholder': 'Please select version',
  'pages.modelTrain.trainingSet': 'Training Set',
  'pages.modelTrain.validationSet': 'Validation Set',
  'pages.modelTrain.paramList': 'Parameter List',
  'pages.modelTrain.paramName': 'Parameter Name',
  'pages.modelTrain.paramValue': 'Parameter Value',
  'pages.modelTrain.paramValueRequired': 'Please enter {paramName}',
  'pages.modelTrain.paramValuePlaceholder': 'Please enter',
  'pages.modelTrain.trainingRatio': 'Training Ratio',
  'pages.modelTrain.crossValidation': 'Cross Validation',
  'pages.modelTrain.trainingTimes': 'Training Times',
  'pages.modelTrain.trainingTimesRequired': 'Please enter training times',
  'pages.modelTrain.trainingTimesPlaceholder': 'Please enter',
  'pages.modelTrain.startTraining': 'Start Training',
  'pages.modelTrain.trainingConfig': 'Training Configuration',
  'pages.modelTrain.trainingProgressAndResult': 'Training Progress and Result',
  'pages.modelTrain.accuracy': 'Accuracy',
  'pages.modelTrain.lossValue': 'Loss Value',
  'pages.modelTrain.trainingProgress': 'Training Progress',
  'pages.modelTrain.accuracyTrend': 'Accuracy Trend',
  'pages.modelTrain.noChartData': 'No chart data available',
  'pages.modelTrain.selectTrainingRecord': 'Please select a training record to view results',
  'pages.modelTrain.queuedTraining': 'Queued Training',
  'pages.modelTrain.historyTraining': 'History Training Models',
  'pages.modelTrain.modelName': 'Model Name',
  'pages.modelTrain.trainingTime': 'Training Time',
  'pages.modelTrain.trainingDuration': 'Training Duration',
  'pages.modelTrain.status': 'Status',
  'pages.modelTrain.operation': 'Operation',
  'pages.modelTrain.details': 'Details',
  'pages.modelTrain.trainingDetail': 'Training Detail',
  'pages.modelTrain.close': 'Close',
  'pages.modelTrain.basicInfo': 'Basic Information',
  'pages.modelTrain.trainingStatus': 'Training Status',
  'pages.modelTrain.startTime': 'Start Time',
  'pages.modelTrain.endTime': 'End Time',
  'pages.modelTrain.epochs': 'Epochs',
  'pages.modelTrain.trainingSetRatio': 'Training Set Ratio',
  'pages.modelTrain.failureReason': 'Failure Reason',
  'pages.modelTrain.paramConfig': 'Parameter Configuration',
  'pages.modelTrain.trainingSetParamConfig': 'Training Set Parameter Configuration',
  'pages.modelTrain.validationSetParamConfig': 'Validation Set Parameter Configuration',
  'pages.modelTrain.trainingResult': 'Training Result',
  'pages.modelTrain.loadModelListFailed': 'Failed to load model list',
  'pages.modelTrain.loadVersionListFailed': 'Failed to load version list',
  'pages.modelTrain.loadParamListFailed': 'Failed to load parameter list',
  'pages.modelTrain.createTrainingSuccess': 'Training task created successfully',
  'pages.modelTrain.createTrainingFailed': 'Failed to create training task',
  'pages.modelTrain.selectModelAndVersion': 'Please select model and version',
  'pages.modelTrain.loadTrainingDetailFailed': 'Failed to load training detail',
  'pages.modelTrain.loadTrainingResultFailed': 'Failed to load training result',
  // Model Test Tab
  'pages.modelTest.testingName': 'Testing Name',
  'pages.modelTest.testingNameRequired': 'Please enter testing name',
  'pages.modelTest.testingNamePlaceholder': 'Please enter',
  'pages.modelTest.testingTimes': 'Testing Times',
  'pages.modelTest.testingTimesRequired': 'Please enter testing times',
  'pages.modelTest.testingTimesPlaceholder': 'Please enter',
  'pages.modelTest.startTesting': 'Start Testing',
  'pages.modelTest.testingConfig': 'Testing Configuration',
  'pages.modelTest.testingProgressAndResult': 'Testing Progress and Result',
  'pages.modelTest.evaluationMetric': 'Evaluation Metric',
  'pages.modelTest.accuracy': 'Accuracy',
  'pages.modelTest.rSquared': 'R-squared',
  'pages.modelTest.lossValue': 'Loss Value',
  'pages.modelTest.noEvaluationData': 'No evaluation metric data available',
  'pages.modelTest.predictionScatter': 'Prediction Scatter Plot',
  'pages.modelTest.noScatterData': 'No scatter plot data available',
  'pages.modelTest.errorDistribution': 'Error Distribution',
  'pages.modelTest.noErrorData': 'No error distribution data available',
  'pages.modelTest.selectTestingRecord': 'Please select a testing record to view results',
  'pages.modelTest.testingSummary': 'Testing Summary',
  'pages.modelTest.noRunningTesting': 'No running testing tasks',
  'pages.modelTest.loadedAllData': 'All data loaded',
  'pages.modelTest.unnamedTesting': 'Unnamed Testing',
  'pages.modelTest.unknownStatus': 'Unknown Status',
  'pages.modelTest.model': 'Model',
  'pages.modelTest.version': 'Version',
  'pages.modelTest.detailedTestingResult': 'Detailed Testing Result',
  'pages.modelTest.testingTime': 'Testing Time',
  'pages.modelTest.viewDetails': 'View Details',
  'pages.modelTest.loadModelListFailed': 'Failed to load model list',
  'pages.modelTest.loadVersionListFailed': 'Failed to load version list',
  'pages.modelTest.loadParamListFailed': 'Failed to load parameter list',
  'pages.modelTest.loadTestingRecordFailed': 'Failed to load testing record',
  'pages.modelTest.loadTestingResultFailed': 'Failed to load testing result',
  'pages.modelTest.createTestingSuccess': 'Testing task created successfully',
  'pages.modelTest.createTestingFailed': 'Failed to create testing task',
  'pages.modelTest.selectModelAndVersion': 'Please select model and version',
  // Model List
  'pages.modelList.noRunningTraining': 'No running training tasks',
  'pages.modelList.loadedAllData': 'All data loaded',
  'pages.modelList.unnamedTraining': 'Unnamed Training',
  'pages.modelList.unknownStatus': 'Unknown Status',
  'pages.modelList.loadTrainingRecordFailed': 'Failed to load training record',
  // Model Connect
  'pages.modelConnect.taskName': 'Task Name',
  'pages.modelConnect.taskType': 'Task Type',
  'pages.modelConnect.taskStatus': 'Task Status',
  'pages.modelConnect.taskId': 'Task ID',
  'pages.modelConnect.createTime': 'Create Time',
  'pages.modelConnect.finishTime': 'Finish Time',
  'pages.modelConnect.taskDescription': 'Task Description',
  'pages.modelConnect.operation': 'Operation',
  'pages.modelConnect.details': 'Details',
  'pages.modelConnect.download': 'Download',
  'pages.modelConnect.taskIdNotExists': 'Task ID does not exist, cannot view details',
  'pages.modelConnect.status.completed': 'Completed',
  'pages.modelConnect.status.complete': 'Complete',
  'pages.modelConnect.status.success': 'Success',
  'pages.modelConnect.status.processing': 'Processing',
  'pages.modelConnect.status.running': 'Running',
  'pages.modelConnect.status.inProgress': 'In Progress',
  'pages.modelConnect.status.pending': 'Pending',
  'pages.modelConnect.status.queued': 'Queued',
  'pages.modelConnect.status.waiting': 'Waiting',
  'pages.modelConnect.status.failed': 'Failed',
  'pages.modelConnect.status.error': 'Error',
  // Experiment
  'pages.experiment.syncingAllData': 'Syncing all external system data...',
  'pages.experiment.syncCompleted': 'Sync completed',
  'pages.experiment.limsIntegration': 'LIMS System Integration',
  'pages.experiment.plmIntegration': 'PLM System Integration',
  'pages.experiment.simulationIntegration': 'Simulation Platform Integration',
  'pages.experiment.externalSystemIntegration': 'External System Integration Management Platform',
  'pages.experiment.syncAllData': 'Sync All Data',
  'pages.experiment.limsData': 'LIMS Experiment Data',
  'pages.experiment.plmFormula': 'PLM Formula Count',
  'pages.experiment.simulationTask': 'Simulation Task Count',
  'pages.experiment.todaySync': 'Today Sync',
  // Configuration Manager
  'pages.configurationManager.metadata': 'Metadata',
  'pages.configurationManager.isPhysical': 'Is Physical',
  'pages.configurationManager.yes': 'Yes',
  'pages.configurationManager.no': 'No',
  'pages.configurationManager.serialNumber': 'Serial Number',
  'pages.configurationManager.metadataEnName': 'Element English Name',
  'pages.configurationManager.unitName': 'Unit Name',
  'pages.configurationManager.unitEnName': 'Unit English Name',
  'pages.configurationManager.unit': 'Unit',
  'pages.configurationManager.lastModifyTime': 'Last Modify Time',
  'pages.configurationManager.lastModifyUser': 'Last Modify User',
  'pages.configurationManager.deleteSuccess': 'Delete successful',
  'pages.configurationManager.deleteFailed': 'Delete failed, please try again',
  'pages.configurationManager.confirmDelete': 'Are you sure to delete this metadata?',
  // Home Page
  'pages.home.systemTitle': 'Molten Salt Property Data Management and Intelligent Analysis System',
  'pages.home.systemSubtitle': 'AI-based Materials Science Data Platform',
  'pages.home.totalDataCount': 'Total Data Count',
  'pages.home.continuousGrowth': 'Continuous Growth',
  'pages.home.activeModel': 'Active Model',
  'pages.home.running': 'Running',
  'pages.home.runningTask': 'Running Task',
  'pages.home.realTimeUpdate': 'Real-time Update',
  'pages.home.dataOverview': 'Data Overview',
  'pages.home.intelligentAnalysis': 'Intelligent Analysis',
  'pages.home.performanceMonitorModel': 'Performance Monitor Model (Accuracy)',
  'pages.home.anomalyMonitorModel': 'Anomaly Monitor Model (Accuracy)',
  'pages.home.taskMonitor': 'Task Monitor',
  'pages.home.completed': 'Completed',
  'pages.home.queued': 'Queued',
  'pages.home.dataGrowthTrend': 'Data Growth Trend',
  'pages.home.monthlyGrowthRate': 'Monthly Growth Rate',
  'pages.home.quickActions': 'Quick Actions',
  'pages.home.dataUpload': 'Data Upload',
  'pages.home.dataAnalysis': 'Data Analysis',
  'pages.home.dataVisualization': 'Data Visualization',
  'pages.home.modelTraining': 'Model Training',
  'pages.home.systemStatus': 'System Status',
  'pages.home.database': 'Database',
  'pages.home.normal': 'Normal',
  'pages.home.apiService': 'API Service',
  'pages.home.storageSpace': 'Storage Space',
  'pages.home.materialTypeStatistics': 'Molten Salt Material Type Statistics',
  'pages.home.fluoride': 'Fluoride',
  'pages.home.chloride': 'Chloride',
  'pages.home.nitrate': 'Nitrate',
  'pages.home.carbonate': 'Carbonate',
  'pages.home.other': 'Other',
  'pages.home.materialPropertyOverview': 'Material Property Overview',
  'pages.home.avgMeltingPoint': 'Average Melting Point',
  'pages.home.avgHeatCapacity': 'Average Heat Capacity',
  'pages.home.avgThermalConductivity': 'Average Thermal Conductivity',
  'pages.home.avgDensity': 'Average Density',
  'pages.home.temperatureRange': 'Temperature Range',
  'pages.home.meltingPoint': 'Melting Point',
  'pages.home.heatCapacity': 'Heat Capacity',
  'pages.home.dataSourceStatistics': 'Data Source Statistics',
  'pages.home.experimentData': 'Experiment Data',
  'pages.home.simulationCalculation': 'Simulation Calculation',
  'pages.home.literatureData': 'Literature Data',
  'pages.home.dataQualityScore': 'Data Quality Score',
  'pages.home.comprehensiveIntegrity': 'Comprehensive integrity, accuracy, credibility',
  'pages.home.dataTrendAnalysis': 'Data Trend Analysis',
  'pages.home.monthlyNewData': 'Monthly New Data',
  'pages.home.dataIntegrity': 'Data Integrity',
  'pages.home.pendingReviewData': 'Pending Review Data',
  'pages.home.verifiedData': 'Verified Data',
  'pages.home.recentMaterials': 'Recent Materials',
  'pages.home.temperatureRangeDistribution': 'Applicable Temperature Range Distribution',
  'pages.home.lowTemp': 'Low Temp (< 400°C)',
  'pages.home.midTemp': 'Mid Temp (400-700°C)',
  'pages.home.highTemp': 'High Temp (> 700°C)',
  'pages.home.popularMaterials': 'Popular Materials',
  'pages.home.hot': 'Hot',
  'pages.home.usageCount': 'Usage Count',
  'pages.home.application': 'Application',
  // Data Export
  'pages.dataExport.getDataFailed': 'Failed to get data',
  'pages.dataExport.getDataFailedRetry': 'Failed to get data, please try again',
  'pages.dataExport.noDataToExport': 'No data to export, please query first',
  'pages.dataExport.fillSystemAndPhysicalType': 'Please fill in and query system and physical type first',
  'pages.dataExport.chartNotReady': 'Chart is not ready yet, please try again later',
  'pages.dataExport.generatingReport': 'Generating report, please wait...',
  'pages.dataExport.generateChartImageFailed': 'Failed to generate chart image',
  'pages.dataExport.chartUploadFailed': 'Chart upload failed',
  'pages.dataExport.reportExportSuccess': 'Report exported successfully',
  'pages.dataExport.reportExportFailed': 'Report export failed, please try again later',
  'pages.dataExport.includePhysicalSubstance': 'Include Physical Substance',
  'pages.dataExport.includeMetadata': 'Include Metadata (Test Conditions, etc.)',
  'pages.dataExport.includeFormulaAndCurve': 'Include Fitting Formula and Curve',
  'pages.dataExport.materialParams': 'Material Parameters',
  'pages.dataExport.pleaseQueryFirst': 'Please enter query conditions first',
  'pages.dataExport.physicalData': 'Physical Data',
  'pages.dataExport.physicalAnalysisAndFitting': 'Physical Analysis and Fitting',
  'pages.dataExport.noDataPleaseQuery': 'No data, please query physical data first',
  'pages.dataExport.exportOptions': 'Export Options',
  'pages.dataExport.exportExcel': 'Export Excel',
  'pages.dataExport.exportPDF': 'Export PDF',
  'pages.dataExport.generateAndExportReport': 'Generate and Export Report',
  // Model Connect
  'pages.modelConnect.multiscaleModelingTaskList': 'Multiscale Modeling Task List',
  'pages.modelConnect.createMdTask': 'Create MD Task',
  'pages.modelConnect.createDftTask': 'Create DFT Task',
  'pages.modelConnect.totalRecords': 'Total {total} records',
  'pages.modelConnect.dftTaskModal.title': 'Create DFT Integration Task',
  'pages.modelConnect.dftTaskModal.taskName': 'Task Name',
  'pages.modelConnect.dftTaskModal.taskNameRequired': 'Please enter task name',
  'pages.modelConnect.dftTaskModal.taskNamePlaceholder': 'Please enter task name',
  'pages.modelConnect.dftTaskModal.taskDescription': 'Task Description',
  'pages.modelConnect.dftTaskModal.taskDescriptionPlaceholder': 'Please enter task description (optional)',
  'pages.modelConnect.dftTaskModal.saltMoleculeUnit': 'Salt Molecule Unit',
  'pages.modelConnect.dftTaskModal.saltMoleculeUnitExtra': 'e.g.: LiF, ThF4, UF4',
  'pages.modelConnect.dftTaskModal.saltMoleculeUnitPlaceholder': 'Please enter salt molecule unit',
  'pages.modelConnect.dftTaskModal.electronicStructureCalc': 'Electronic Structure Calculation Parameters (JSON format)',
  'pages.modelConnect.dftTaskModal.electronicStructureCalcExtra': 'e.g.: {"method": "DFT", "basis_set": "6-31G", "functional": "B3LYP"}',
  'pages.modelConnect.dftTaskModal.electronicStructureCalcPlaceholder': 'e.g.: {"method": "DFT", "basis_set": "6-31G", "functional": "B3LYP"}',
  'pages.modelConnect.dftTaskModal.calculationParams': 'Calculation Parameters (JSON format)',
  'pages.modelConnect.dftTaskModal.calculationParamsExtra': 'e.g.: {"convergence": 1e-6, "max_iterations": 100}',
  'pages.modelConnect.dftTaskModal.calculationParamsPlaceholder': 'e.g.: {"convergence": 1e-6, "max_iterations": 100}',
  'pages.modelConnect.dftTaskModal.inputFile': 'Input File (optional)',
  'pages.modelConnect.dftTaskModal.inputFileExtra': 'Please upload file, file ID will be automatically filled after successful upload',
  'pages.modelConnect.dftTaskModal.uploadText': 'Click or drag file to this area to upload',
  'pages.modelConnect.dftTaskModal.uploadHint': 'Support single file upload',
  'pages.modelConnect.dftTaskModal.createTask': 'Create Task',
  'pages.modelConnect.dftTaskModal.uploadSuccess': '{fileName} uploaded successfully!',
  'pages.modelConnect.dftTaskModal.uploadFailed': '{fileName} upload failed!',
  'pages.modelConnect.dftTaskModal.fileIdNotReturned': 'File uploaded successfully, but file ID was not returned!',
  'pages.modelConnect.dftTaskModal.electronicStructureCalcError': 'Electronic structure calculation parameter format error, please enter valid JSON',
  'pages.modelConnect.dftTaskModal.calculationParamsError': 'Calculation parameter format error, please enter valid JSON',
  'pages.modelConnect.dftTaskModal.createSuccess': 'DFT task created successfully',
  'pages.modelConnect.dftTaskModal.createFailed': 'Failed to create DFT task',
  'pages.modelConnect.dftTaskModal.createFailedRetry': 'Failed to create DFT task, please try again',
  'pages.modelConnect.mdTaskModal.title': 'Create MD Integration Task',
  'pages.modelConnect.mdTaskModal.saltSystem': 'Multi-component Salt System',
  'pages.modelConnect.mdTaskModal.saltSystemRequired': 'Please enter multi-component salt system',
  'pages.modelConnect.mdTaskModal.saltSystemExtra': 'e.g.: LiF–ThF₄–UF₄',
  'pages.modelConnect.mdTaskModal.saltSystemPlaceholder': 'e.g.: LiF–ThF₄–UF₄',
  'pages.modelConnect.mdTaskModal.temperature': 'Temperature Value',
  'pages.modelConnect.mdTaskModal.temperatureRequired': 'Please enter temperature value',
  'pages.modelConnect.mdTaskModal.temperatureUnit': 'Temperature Unit',
  'pages.modelConnect.mdTaskModal.temperatureUnitPlaceholder': 'Please select temperature unit',
  'pages.modelConnect.mdTaskModal.pressure': 'Pressure Value',
  'pages.modelConnect.mdTaskModal.pressureUnit': 'Pressure Unit',
  'pages.modelConnect.mdTaskModal.pressureUnitPlaceholder': 'e.g.: bar',
  'pages.modelConnect.mdTaskModal.potentialFunctionSource': 'Potential Function Source',
  'pages.modelConnect.mdTaskModal.potentialFunctionSourceRequired': 'Please select potential function source',
  'pages.modelConnect.mdTaskModal.potentialFunctionSourcePlaceholder': 'Please select potential function source',
  'pages.modelConnect.mdTaskModal.dftResultId': 'Associated DFT Result ID',
  'pages.modelConnect.mdTaskModal.dftResultIdExtra': 'Required only when potential function source is DFT',
  'pages.modelConnect.mdTaskModal.saltComposition': 'Salt Composition Information (JSON format)',
  'pages.modelConnect.mdTaskModal.saltCompositionExtra': 'e.g.: {"LiF": 0.5, "ThF4": 0.3, "UF4": 0.2}',
  'pages.modelConnect.mdTaskModal.saltCompositionPlaceholder': 'e.g.: {"LiF": 0.5, "ThF4": 0.3, "UF4": 0.2}',
  'pages.modelConnect.mdTaskModal.simulationParams': 'Simulation Parameters (JSON format)',
  'pages.modelConnect.mdTaskModal.simulationParamsPlaceholder': 'e.g.: {"ensemble": "NVT", "time_step": 0.001, "total_time": 1000}',
  'pages.modelConnect.mdTaskModal.saltCompositionError': 'Salt composition information format error, please enter valid JSON',
  'pages.modelConnect.mdTaskModal.simulationParamsError': 'Simulation parameter format error, please enter valid JSON',
  'pages.modelConnect.mdTaskModal.createSuccess': 'MD task created successfully',
  'pages.modelConnect.mdTaskModal.createFailed': 'Failed to create MD task',
  'pages.modelConnect.mdTaskModal.createFailedRetry': 'Failed to create MD task, please try again',
  'pages.modelConnect.taskDetailsModal.title': 'Task Details',
  'pages.modelConnect.taskDetailsModal.taskInfo': 'Task Information',
  'pages.modelConnect.taskDetailsModal.dftTaskInfo': 'DFT Task Information',
  'pages.modelConnect.taskDetailsModal.mdTaskInfo': 'MD Task Information',
  'pages.modelConnect.taskDetailsModal.saltMoleculeUnit': 'Salt Molecule Unit',
  'pages.modelConnect.taskDetailsModal.inputFilePath': 'Input File Path',
  'pages.modelConnect.taskDetailsModal.outputFilePath': 'Output File Path',
  'pages.modelConnect.taskDetailsModal.bindingEnergy': 'Binding Energy',
  'pages.modelConnect.taskDetailsModal.ionPotential': 'Ion Potential',
  'pages.modelConnect.taskDetailsModal.resultFilePath': 'Result File Path',
  'pages.modelConnect.taskDetailsModal.saltSystem': 'Multi-component Salt System',
  'pages.modelConnect.taskDetailsModal.temperature': 'Temperature',
  'pages.modelConnect.taskDetailsModal.pressure': 'Pressure',
  'pages.modelConnect.taskDetailsModal.potentialFunctionSource': 'Potential Function Source',
  'pages.modelConnect.taskDetailsModal.dftResultId': 'Associated DFT Result ID',
  'pages.modelConnect.taskDetailsModal.diffusionCoefficient': 'Diffusion Coefficient',
  'pages.modelConnect.taskDetailsModal.thermalConductivity': 'Thermal Conductivity',
  'pages.modelConnect.taskDetailsModal.viscosity': 'Viscosity',
  'pages.modelConnect.taskDetailsModal.getDetailFailed': 'Failed to get task details',
  // Audit Compliance
  'pages.auditCompliance.operator': 'Operator',
  'pages.auditCompliance.operatorPlaceholder': 'Please enter operator',
  'pages.auditCompliance.moduleName': 'Module Name',
  'pages.auditCompliance.moduleNamePlaceholder': 'Please enter module name',
  'pages.auditCompliance.operationType': 'Operation Type',
  'pages.auditCompliance.operationTime': 'Operation Time',
  'pages.auditCompliance.operationStatus': 'Operation Status',
  'pages.auditCompliance.operationDescription': 'Operation Description',
  'pages.auditCompliance.clientIP': 'Client IP',
  'pages.auditCompliance.operationLogList': 'Operation Log List',
  'pages.auditCompliance.success': 'Success',
  'pages.auditCompliance.failed': 'Failed',
  'pages.auditCompliance.queryFailed': 'Query failed',
  'pages.auditCompliance.queryFailedRetry': 'Query failed, please try again later',
  'pages.auditCompliance.serialNumber': 'Serial Number',
  'pages.auditCompliance.upload': 'Upload',
  'pages.auditCompliance.submit': 'Submit',
  'pages.auditCompliance.change': 'Change',
  'pages.auditCompliance.config': 'Config',
  'pages.auditCompliance.download': 'Download',
  'pages.auditCompliance.modify': 'Modify',
  // Performance Prediction
  'pages.performancePrediction.predictionResults': 'Prediction Results',
  'pages.performancePrediction.saltSystem': 'Salt System',
  'pages.performancePrediction.temperatureRange': 'Temperature Range',
  'pages.performancePrediction.algorithmType': 'Algorithm Type',
  'pages.performancePrediction.dataSource': 'Data Source',
  'pages.performancePrediction.exampleData': 'Example Data',
  'pages.performancePrediction.showJsonData': 'Show JSON Data',
  'pages.performancePrediction.hideJsonData': 'Hide JSON Data',
  'pages.performancePrediction.copy': 'Copy',
  'pages.performancePrediction.noPropertyResults': 'No property result data available',
  'pages.performancePrediction.fittingEquation': 'Fitting Equation',
  'pages.performancePrediction.fittingPoints': 'Fitting Points',
  'pages.performancePrediction.fittingPointData': 'Fitting Point Data',
  'pages.performancePrediction.fittingCurve': 'Fitting Curve Chart',
  'pages.performancePrediction.propertyDescription': 'Property Description',
  'pages.performancePrediction.suggestions': 'Suggestions',
  // Properties Grouper
  'pages.propertiesGrouper.screeningResults': 'Screening Results',
  'pages.propertiesGrouper.saltSystemComposition': 'Salt System Composition',
  'pages.propertiesGrouper.analysisType': 'Analysis Type',
  'pages.propertiesGrouper.analysisMethod': 'Analysis Method',
  'pages.propertiesGrouper.classificationResult': 'Classification Result',
  'pages.propertiesGrouper.clusteringResult': 'Clustering Result',
  'pages.propertiesGrouper.stabilityLevel': 'Stability Level',
  'pages.propertiesGrouper.corrosionLevel': 'Corrosion Level',
  'pages.propertiesGrouper.confidenceScore': 'Confidence Score',
  'pages.propertiesGrouper.suggestions': 'Suggestions',
  'pages.propertiesGrouper.classificationDetails': 'Classification Details',
  'pages.propertiesGrouper.clusterDescription': 'Cluster Description',
  'pages.propertiesGrouper.similarityScore': 'Similarity Score',
  'pages.propertiesGrouper.clusterMembers': 'Cluster Members',
  'pages.propertiesGrouper.clusterCenter': 'Cluster Center',
  'pages.propertiesGrouper.commonPatterns': 'Common Patterns',
  'pages.propertiesGrouper.unnamedCluster': 'Unnamed',
  // More Details Modal
  'pages.moreDetails.title': 'Analysis Result Visualization',
  'pages.moreDetails.getResultFailed': 'Failed to get task results',
  'pages.moreDetails.getResultFailedRetry': 'Failed to get task results, please try again',
  'pages.moreDetails.taskIdNotExists': 'Task ID does not exist',
  'pages.moreDetails.downloadPngStarted': 'Started downloading PNG chart',
  'pages.moreDetails.downloadCsvStarted': 'Started downloading CSV data',
  'pages.moreDetails.chartDataParseFailed': 'Chart data parsing failed or incorrect format',
  'pages.moreDetails.noChartData': 'No chart data available',
  'pages.moreDetails.fittingResult': 'Fitting Result',
  'pages.moreDetails.fittingModel': 'Fitting Model',
  'pages.moreDetails.goodnessOfFit': 'Goodness of Fit',
  'pages.moreDetails.activationEnergy': 'Activation Energy',
  'pages.moreDetails.preExponentialFactor': 'Pre-exponential Factor',
  'pages.moreDetails.arrheniusEquation': 'Arrhenius Equation',
  'pages.moreDetails.relationChart': 'Relationship Chart',
  'pages.moreDetails.statisticalInfo': 'Statistical Information',
  'pages.moreDetails.dataPoints': 'Data Points',
  'pages.moreDetails.temperatureRange': 'Temperature Range',
  'pages.moreDetails.propertyRange': 'Property Range',
  'pages.moreDetails.standardError': 'Standard Error',
  'pages.moreDetails.resultData': 'Result Data',
  'pages.moreDetails.totalRecords': 'Total {total} records',
  'pages.moreDetails.downloadChart': 'Download Chart (PNG)',
  'pages.moreDetails.downloadData': 'Download Data (CSV)',
  'pages.moreDetails.noVisualizationData': 'No visualization data available',
  // Workflow Target Details
  'pages.experimentCalculate.workflowTargetDetails': 'Workflow Target Details',
  'pages.experimentCalculate.coreObjectives': 'Core Objectives of Experimental-Computational Integrated Workflow',
  'pages.experimentCalculate.coreObjectivesDesc': 'Establish seamless connection between experimental measurement and computational simulation, form a data-driven material development closed-loop, and achieve a complete workflow from experimental verification to performance prediction to optimized design.',
  'pages.experimentCalculate.dataInteroperability': 'Data Interoperability',
  'pages.experimentCalculate.dataInteroperabilityDesc': 'Realize bidirectional flow and mutual verification of experimental data and simulation data',
  'pages.experimentCalculate.experimentalDataStandardization': 'Experimental Data Standardization',
  'pages.experimentCalculate.unifiedFormatUnits': 'Unified Format and Units',
  'pages.experimentCalculate.simulationParameterOptimization': 'Simulation Parameter Optimization',
  'pages.experimentCalculate.basedOnExperimentalData': 'Corrected Based on Experimental Data',
  'pages.experimentCalculate.modelCorrection': 'Model Correction',
  'pages.experimentCalculate.modelCorrectionDesc': 'Use experimental data to optimize computational model parameters and improve prediction accuracy',
  'pages.experimentCalculate.parameterSensitivityAnalysis': 'Parameter Sensitivity Analysis',
  'pages.experimentCalculate.identifyKeyParameters': 'Identify Key Parameters',
  'pages.experimentCalculate.modelValidation': 'Model Validation',
  'pages.experimentCalculate.compareResults': 'Compare Experimental and Simulation Results',
  'pages.experimentCalculate.blankFilling': 'Blank Filling',
  'pages.experimentCalculate.blankFillingDesc': 'Complete extreme conditions that are difficult to measure experimentally through computational simulation',
  'pages.experimentCalculate.extremeConditionsPrediction': 'Extreme Conditions Prediction',
  'pages.experimentCalculate.highTempHighPressure': 'High Temperature, High Pressure, etc.',
  'pages.experimentCalculate.multiscaleSimulation': 'Multiscale Simulation',
  'pages.experimentCalculate.fromAtomToMacro': 'From Atom to Macro',
  'pages.experimentCalculate.accelerateDevelopment': 'Accelerate Development',
  'pages.experimentCalculate.accelerateDevelopmentDesc': 'Shorten the cycle from new material design to verification and reduce R&D costs',
  'pages.experimentCalculate.highThroughputComputing': 'High Throughput Computing',
  'pages.experimentCalculate.quickScreenCandidateMaterials': 'Quick Screen Candidate Materials',
  'pages.experimentCalculate.intelligentRecommendation': 'Intelligent Recommendation',
  'pages.experimentCalculate.optimizeBasedOnHistoricalData': 'Optimize Based on Historical Data',
  // Result Download
  'pages.resultDownload.priorityNormal': 'Normal',
  'pages.resultDownload.priorityHigh': 'High',
  'pages.resultDownload.priorityUrgent': 'Urgent',
  'pages.resultDownload.uploadSuccess': '{fileName} uploaded successfully!',
  'pages.resultDownload.uploadFailed': '{fileName} upload failed!',
  'pages.resultDownload.startWorkflowSuccess': 'Workflow started successfully',
  'pages.resultDownload.startWorkflowFailed': 'Failed to start workflow, please try again',
  'pages.resultDownload.workflowNo': 'Workflow No',
  'pages.resultDownload.workflowName': 'Workflow Name',
  'pages.resultDownload.workflowNamePlaceholder': 'Please enter workflow name',
  'pages.resultDownload.workflowNameRequired': 'Please enter workflow name',
  'pages.resultDownload.workflowType': 'Workflow Type',
  'pages.resultDownload.selectWorkflowType': 'Please select workflow type',
  'pages.resultDownload.workflowTypeRequired': 'Please select workflow type',
  'pages.resultDownload.createTime': 'Create Time',
  'pages.resultDownload.startTime': 'Start Time',
  'pages.resultDownload.endTime': 'End Time',
  'pages.resultDownload.queuePosition': 'Queue Position',
  'pages.resultDownload.priority': 'Priority',
  'pages.resultDownload.selectPriority': 'Please select priority',
  'pages.resultDownload.executionProgress': 'Execution Progress',
  'pages.resultDownload.workflowStatus': 'Workflow Status',
  'pages.resultDownload.operation': 'Operation',
  'pages.resultDownload.startNewWorkflow': 'Start New Workflow',
  'pages.resultDownload.immediateStart': 'Start Immediately',
  'pages.resultDownload.startImmediately': 'Start Immediately',
  'pages.resultDownload.createOnly': 'Create Only',
  'pages.resultDownload.workflowDescription': 'Workflow Description',
  'pages.resultDownload.workflowDescriptionPlaceholder': 'Please enter workflow description',
  'pages.resultDownload.fileUpload': 'File Upload',
  'pages.resultDownload.selectFileUpload': 'Select File to Upload',
  'pages.resultDownload.fileUploaded': 'File uploaded, ID: {fileId}',
  'pages.resultDownload.inputParameters': 'Input Parameters (JSON)',
  'pages.resultDownload.inputParametersPlaceholder': 'Please enter JSON format input parameters, e.g.: {"key":"value"}. File ID will be automatically added to input parameters after upload.',
  'pages.resultDownload.configData': 'Configuration Data (JSON)',
  'pages.resultDownload.configDataPlaceholder': 'Please enter JSON format configuration data, e.g.: {"key":"value"}',
  'pages.resultDownload.templateId': 'Template ID',
  'pages.resultDownload.templateIdPlaceholder': 'Please enter template ID (optional)',
  'pages.resultDownload.submitWorkflow': 'Submit Workflow',
  'pages.resultDownload.queuedWorkflows': 'Queued Workflows',
  'pages.resultDownload.historyWorkflows': 'History Workflows',
  'pages.resultDownload.searchWorkflowName': 'Search Workflow Name',
  'pages.resultDownload.selectStatus': 'Select Status',
  'pages.resultDownload.viewDetails': 'View Details',
  'pages.resultDownload.downloadReport': 'Download Report',
  // Corrosion Solution Related
  'pages.resultDownload.corrosionSolutionTitle': 'Corrosion Problem Solution',
  'pages.resultDownload.corrosionSolutionDiagram': 'Corrosion Problem Solution Diagram',
  'pages.resultDownload.problemAnalysis': 'Problem Analysis',
  'pages.resultDownload.corrosionAnalysis': 'In high-temperature molten salt environments, Cr elements in nickel-based alloys undergo selective corrosion, leading to material performance degradation with corrosion rates of 50-100um/year',
  'pages.resultDownload.solution': 'Solution',
  'pages.resultDownload.solution1': 'Use high-purity materials to control impurities in molten salt',
  'pages.resultDownload.solution2': 'Adopt electrochemical protection technology',
  'pages.resultDownload.solution3': 'Develop new corrosion-resistant alloy materials',
  'pages.resultDownload.solution4': 'Optimize operating temperature and control redox potential',
  'pages.resultDownload.implementationEffect': 'Implementation Effect',
  'pages.resultDownload.implementationResult': 'Through comprehensive application of the above measures, corrosion rate can be reduced to 10-20um/year, significantly extending equipment service life',
  // TaskSubmit Additional Translations
  'pages.experimentCalculate.densityDataDriven': 'Density Data Driven',
  'pages.experimentCalculate.densityDataDrivenDesc': 'Experimental density results are used to correct DFT calculated volume and improve calculation accuracy',
  'pages.experimentCalculate.uploadDensityData': 'Upload experimental density data',
  'pages.experimentCalculate.correctDftVolume': 'Correct DFT calculated volume',
  'pages.experimentCalculate.improveAccuracy': 'Improve calculation accuracy',
  'pages.experimentCalculate.simulationDataFillGaps': 'Simulation Data Fills Experimental Gaps',
  'pages.experimentCalculate.extremeConditionPrediction': 'Extreme Condition Prediction',
  'pages.experimentCalculate.extremeConditionPredictionDesc': 'Extreme conditions (>1000°C) are difficult to measure experimentally, automatically triggering MD/DFT property prediction',
  'pages.experimentCalculate.identifyGaps': 'Identify experimental gap areas',
  'pages.experimentCalculate.triggerMdDft': 'Automatically trigger MD/DFT calculations',
  'pages.experimentCalculate.predictExtremeProperties': 'Predict extreme condition properties',
  'pages.experimentCalculate.phaseDiagramCompletion': 'Phase Diagram Calculation Completion',
  'pages.experimentCalculate.phaseDiagramCompletionDesc': 'CALPHAD phase diagram calculation supplements multi-component phase stability information',
  'pages.experimentCalculate.inputMultiComponent': 'Input multi-component system',
  'pages.experimentCalculate.calphadCalculation': 'CALPHAD phase diagram calculation',
  'pages.experimentCalculate.supplementPhaseStability': 'Supplement phase stability information',
  // TaskSubmit Components Additional Translations

  // Details3.tsx - Step 2 Simulation Tools
  'pages.experimentCalculate.step3.mdTitle': 'Molecular Dynamics (MD)',
  'pages.experimentCalculate.step3.mdDesc': 'Simulate molten salt microstructure and transport properties',
  'pages.experimentCalculate.step3.toolLammps': 'LAMMPS',
  'pages.experimentCalculate.step3.toolGromacs': 'GROMACS',
  'pages.experimentCalculate.step3.toolCustom': 'Custom Force Field',
  'pages.experimentCalculate.step3.dftTitle': 'Density Functional Theory (DFT)',
  'pages.experimentCalculate.step3.dftDesc': 'Calculate electronic structure and thermodynamic properties',
  'pages.experimentCalculate.step3.toolVasp': 'VASP',
  'pages.experimentCalculate.step3.toolQe': 'Quantum ESPRESSO',
  'pages.experimentCalculate.step3.toolCastep': 'CASTEP',
  'pages.experimentCalculate.step3.calphadTitle': 'CALPHAD Method',
  'pages.experimentCalculate.step3.calphadDesc': 'Calculate phase diagrams and thermodynamic properties',
  'pages.experimentCalculate.step3.toolThermoCalc': 'Thermo-Calc',
  'pages.experimentCalculate.step3.toolFactSage': 'FactSage',
  'pages.experimentCalculate.step3.toolPandat': 'Pandat',
  // Details4.tsx - Step 4 Verification & Optimization
  // Details5.tsx - Step 5 Performance Prediction
  // MoreDetails.tsx - Analysis Result Visualization
  // Details2.tsx - Step 1 Experimental Data
  'pages.experimentCalculate.step2.viscosityData': 'Viscosity Data',
  'pages.experimentCalculate.step2.viscosityRelation': 'η-T relation',
  'pages.experimentCalculate.step2.densityData': 'Density Data',
  'pages.experimentCalculate.step2.densityRelation': 'ρ-T relation',
  'pages.experimentCalculate.step2.specificHeatData': 'Specific Heat Data',
  'pages.experimentCalculate.step2.specificHeatRelation': 'Cp-T relation',
  'pages.experimentCalculate.step2.thermalConductivityData': 'Thermal Conductivity Data',
  'pages.experimentCalculate.step2.thermalConductivityRelation': 'λ-T relation',
  'pages.experimentCalculate.step2.electricalConductivityData': 'Electrical Conductivity Data',
  'pages.experimentCalculate.step2.electricalConductivityRelation': 'σ-T relation',
  // Additional ResultDownload Keys
  'pages.resultDownload.parameter': 'Parameter',
  'pages.resultDownload.experimentalValue': 'Experimental Value',
  'pages.resultDownload.simulationValue': 'Simulation Value',
  'pages.resultDownload.error': 'Error',
  'pages.resultDownload.status': 'Status',
  'pages.resultDownload.workflowHistoryDetail': 'Workflow History Detail',
  'pages.resultDownload.workflowDesc': 'Workflow Description',
  'pages.resultDownload.actualDuration': 'Actual',
  'pages.resultDownload.estimated': 'Estimated',
  'pages.resultDownload.minutes': 'minutes',
  'pages.resultDownload.processingLog': 'Processing Log',
  'pages.resultDownload.workflowCompleted': 'Workflow execution completed',
  'pages.resultDownload.downloadFullReport': 'Download Full Report',
  // DataFlow Additional Translations
  'pages.dataFlow.taskList': 'Task List',
  'pages.dataFlow.createEtlTask': 'Create ETL Task',
  'pages.dataFlow.refresh': 'Refresh',
  'pages.dataFlow.dataExtract': 'Data Extract',
  'pages.dataFlow.dataTransform': 'Data Transform',
  'pages.dataFlow.dataLoad': 'Data Load',
  'pages.dataFlow.supportedFormats': 'Supported Formats',
  'pages.dataFlow.unitStandardization': 'Unit Standardization',
  'pages.dataFlow.dataCleaning': 'Data Cleaning',
  'pages.dataFlow.dataCleaningDesc': 'Outlier removal, curve smoothing',
  'pages.dataFlow.missingDataCompletion': 'Missing Data Completion',
  'pages.dataFlow.missingDataCompletionDesc': 'Interpolation/ML-based prediction',
  'pages.dataFlow.metadataStandardization': 'Metadata Standardization',
  'pages.dataFlow.metadataStandardizationDesc': 'Experimental conditions, simulation parameters standardization',
  'pages.dataFlow.dataWarehouse': 'Data Warehouse',
  'pages.dataFlow.writeToDataWarehouse': 'Write to molten salt property data warehouse',
  'pages.dataFlow.versionManagement': 'Version Management',
  'pages.dataFlow.versionManagementDesc': 'Retain original data + converted data',
  'pages.dataFlow.dataLabeling': 'Data Labeling',
  'pages.dataFlow.dataLabelingExample': 'e.g.: LiF–BeF₂ (66–34 mol%) | 850°C | η = 2.5 mPa·s',
  'pages.dataFlow.etlPipelineTitle': 'ETL Data Processing Pipeline',
  'pages.dataFlow.getTaskDetailFailed': 'Failed to get task details',
  'pages.dataFlow.getTaskDetailFailedRetry': 'Failed to get task details, please try again later',
  'pages.dataFlow.deleteSuccess': 'Delete successful',
  'pages.dataFlow.deleteFailed': 'Delete failed',
  'pages.dataFlow.deleteFailedRetry': 'Failed to delete task, please try again later',
  // CreateTaskModal Additional Translations
  'pages.createTaskModal.title': 'Create ETL Task',
  'pages.createTaskModal.taskName': 'Task Name',
  'pages.createTaskModal.taskNamePlaceholder': 'Please enter task name',
  'pages.createTaskModal.taskNameRequired': 'Please enter task name',
  'pages.createTaskModal.dataSourceType': 'Data Source Type',
  'pages.createTaskModal.selectDataSourceType': 'Please select data source type',
  'pages.createTaskModal.dataSourceTypeRequired': 'Please select data source type',
  'pages.createTaskModal.dataSourceDetail': 'Specific Source',
  'pages.createTaskModal.selectDataSourceDetail': 'Please select specific source',
  'pages.createTaskModal.dataSourceDetailRequired': 'Please select specific source',
  'pages.createTaskModal.fileFormat': 'File Format',
  'pages.createTaskModal.selectFileFormat': 'Please select file format',
  'pages.createTaskModal.fileFormatRequired': 'Please select file format',
  'pages.createTaskModal.uploadFile': 'Upload File',
  'pages.createTaskModal.uploadFileRequired': 'Please upload file',
  'pages.createTaskModal.uploadHint': 'Click or drag file here to upload',
  'pages.createTaskModal.uploadFormatHint': 'Support {formats} format, file size not exceeding 100MB',
  'pages.createTaskModal.unsupportedFormat': 'Only {formats} format files are supported!',
  'pages.createTaskModal.fileSizeExceeded': 'File size cannot exceed 100MB!',
  'pages.createTaskModal.uploadSuccess': '{fileName} uploaded successfully!',
  'pages.createTaskModal.uploadFailed': '{fileName} upload failed!',
  'pages.createTaskModal.pleaseUploadFile': 'Please upload file first!',
  'pages.createTaskModal.createSuccess': 'Task created successfully!',
  'pages.createTaskModal.createFailed': 'Task creation failed',
  'pages.createTaskModal.createFailedRetry': 'Task creation failed, please try again later',
  // TaskDetailModal Additional Translations
  'pages.taskDetailModal.title': 'Task Details',
  'pages.taskDetailModal.basicInfo': 'Basic Task Information',
  'pages.taskDetailModal.taskNo': 'Task No',
  'pages.taskDetailModal.taskName': 'Task Name',
  'pages.taskDetailModal.dataSourceType': 'Data Source Type',
  'pages.taskDetailModal.dataSourceDetail': 'Specific Source',
  'pages.taskDetailModal.fileFormat': 'File Format',
  'pages.taskDetailModal.fileName': 'File Name',
  'pages.taskDetailModal.taskStatus': 'Task Status',
  'pages.taskDetailModal.createTime': 'Create Time',
  'pages.taskDetailModal.startTime': 'Start Time',
  'pages.taskDetailModal.endTime': 'End Time',
  'pages.taskDetailModal.errorMessage': 'Error Message',
  'pages.taskDetailModal.processingProgress': 'Processing Progress',
  'pages.taskDetailModal.totalProgress': 'Total Progress',
  'pages.taskDetailModal.extractProgress': 'Extract Progress',
  'pages.taskDetailModal.transformProgress': 'Transform Progress',
  'pages.taskDetailModal.loadProgress': 'Load Progress',
  'pages.taskDetailModal.recordStatistics': 'Record Statistics',
  'pages.taskDetailModal.totalRecords': 'Total Records',
  'pages.taskDetailModal.extractedRecords': 'Extracted Records',
  'pages.taskDetailModal.transformedRecords': 'Transformed Records',
  'pages.taskDetailModal.loadedRecords': 'Loaded Records',
  'pages.taskDetailModal.pending': 'Pending',
  'pages.taskDetailModal.extracting': 'Extracting',
  'pages.taskDetailModal.transforming': 'Transforming',
  'pages.taskDetailModal.loading': 'Loading',
  'pages.taskDetailModal.completed': 'Completed',
  'pages.taskDetailModal.failed': 'Failed',
  'pages.taskDetailModal.inProgress': 'In Progress',
  // TaskManager TaskSubmit Additional Translations
  'pages.taskSubmit.submitSuccess': 'Task submitted successfully',
  'pages.taskSubmit.submitFailed': 'Task submission failed, please try again',
  'pages.taskSubmit.taskName': 'Task Name',
  'pages.taskSubmit.taskNamePlaceholder': 'Please enter task name',
  'pages.taskSubmit.taskNameRequired': 'Please enter task name',
  'pages.taskSubmit.taskDescription': 'Task Description',
  'pages.taskSubmit.taskDescriptionPlaceholder': 'Please enter task description',
  'pages.taskSubmit.inputSystem': 'Input System',
  'pages.taskSubmit.inputSystemPlaceholder': 'Please enter input system',
  'pages.taskSubmit.selectDataSource': 'Please select database',
  'pages.taskSubmit.selectPhysicalType': 'Please select physical property type',
  'pages.taskSubmit.taskType': 'Task Type',
  'pages.taskSubmit.selectTaskType': 'Please select task type',
  'pages.taskSubmit.taskTypeRequired': 'Please select task type',
  'pages.taskSubmit.modelType': 'Model Selection',
  'pages.taskSubmit.selectModel': 'Please select model',
  'pages.taskSubmit.modelTypeRequired': 'Please select model',
  'pages.taskSubmit.compositionRatio': 'Composition Ratio',
  'pages.taskSubmit.compositionRatioTooltip': 'e.g.: 20-40mol%',
  'pages.taskSubmit.compositionRatioPlaceholder': 'e.g.: 20-40mol%',
  'pages.taskSubmit.temperatureRange': 'Temperature Range',
  'pages.taskSubmit.temperatureRangeTooltip': 'e.g.: 500-600°C',
  'pages.taskSubmit.temperatureRangePlaceholder': 'e.g.: 500-600°C',
  'pages.taskSubmit.submitTask': 'Submit Analysis Task',
  // ProjectExperience Additional Translations
  'pages.projectExperience.queryFailed': 'Query failed',
  'pages.projectExperience.keyword': 'Keyword',
  'pages.projectExperience.projectType': 'Project Type',
  'pages.projectExperience.other': 'Other',
  'pages.projectExperience.runningData': 'Running Data',
  'pages.projectExperience.projectName': 'Project Name',
  'pages.projectExperience.saltSystem': 'Salt System',
  'pages.projectExperience.viewSolution': 'View Solution',
  'pages.projectExperience.viewReport': 'View Detailed Report',
  'pages.projectExperience.inputQuery': 'Please enter query conditions to search',
  'pages.projectExperience.noData': 'No Data',
  'pages.projectExperience.projectDetailedReport': 'Project Detailed Report',
  'pages.projectExperience.projectOverview': 'Project Overview',
  'pages.projectExperience.technicalFeatures': 'Technical Features',
  'pages.projectExperience.achievementsExperience': 'Achievements and Experience',
  'pages.projectExperience.projectDetails': 'Project Details',
  // PerformancePrediction
  'pages.performancePrediction.title': 'Performance Prediction',
  'pages.performancePrediction.params': 'Prediction Parameters',
  'pages.performancePrediction.saltSystem.required': 'Please enter salt system composition',
  'pages.performancePrediction.saltSystem.extra': 'e.g.: LiF-BeF2 45-55 mol% or LiF-BeF2',
  'pages.performancePrediction.saltSystem.placeholder': 'e.g.: LiF-BeF2 45-55 mol% or LiF-BeF2',
  'pages.performancePrediction.temperatureMin.required': 'Please enter minimum temperature',
  'pages.performancePrediction.temperatureMin.placeholder': 'e.g.: 500',
  'pages.performancePrediction.temperatureMax.required': 'Please enter maximum temperature',
  'pages.performancePrediction.temperatureMax.placeholder': 'e.g.: 800',
  'pages.performancePrediction.impurityConcentration': 'Impurity Concentration (JSON format)',
  'pages.performancePrediction.impurityConcentration.extra': 'Optional, JSON format, e.g. {"Element Name": Concentration Value} e.g. {"Fe": 0.01, "Ni": 0.005}',
  'pages.performancePrediction.impurityConcentration.placeholder': 'e.g.: {"Fe": 0.01, "Ni": 0.005}',
  'pages.performancePrediction.impurityFormatError': 'Impurity concentration format error, please check JSON format',
  'pages.performancePrediction.processParameters': 'Process Parameters (JSON format)',
  'pages.performancePrediction.processParameters.extra': 'Optional, JSON format, e.g. {"Parameter Name": Parameter Value} e.g. {"pressure": 1.0, "atmosphere": "argon"}',
  'pages.performancePrediction.processParameters.placeholder': 'e.g.: {"pressure": 1.0, "atmosphere": "argon"}',
  'pages.performancePrediction.processFormatError': 'Process parameters format error, please check JSON format',
  'pages.performancePrediction.algorithmType.required': 'Please select algorithm type',
  'pages.performancePrediction.algorithmType.extra': 'Regression models: Random Forest, XGBoost, Neural Network; Deep learning models: Graph Neural Network (GNN)',
  'pages.performancePrediction.algorithmType.placeholder': 'Please select algorithm',
  'pages.performancePrediction.start': 'Start Prediction',
  'pages.performancePrediction.reset': 'Reset',
  'pages.performancePrediction.success': 'Prediction successful',
  'pages.performancePrediction.failure': 'Prediction failed, please try again',
  'pages.performancePrediction.copySuccess': 'JSON data copied to clipboard',
  'pages.performancePrediction.tip': 'Operation Tips',
  'pages.performancePrediction.tip.description': 'Please fill in prediction parameters on the left, then click the "Start Prediction" button',
  // MeterialGraph
  'pages.meterialGraph.querySuccess': 'Query successful',
  'pages.meterialGraph.queryFailed': 'Query failed',
  'pages.meterialGraph.queryFailedRetry': 'Query failed, please try again later',
  'pages.meterialGraph.inputQuery': 'Please enter query content',
  'pages.meterialGraph.system': 'System',
  'pages.meterialGraph.nodeType': 'Node Type',
  'pages.meterialGraph.all': 'All',
  'pages.meterialGraph.temperatureRange': 'Temperature Range',
  'pages.meterialGraph.physicalType': 'Physical Property Type',
  'pages.meterialGraph.emptyDescription': 'Please enter query conditions above and click the query button to generate knowledge graph and system information',
  'pages.meterialGraph.knowledgeGraph': 'Knowledge Graph',
  'pages.meterialGraph.generating': 'Knowledge graph generating...',
  'pages.meterialGraph.currentSystemInfo': 'Current System Information',
  'pages.meterialGraph.unknownSystem': 'Unknown System',
  'pages.meterialGraph.noDescription': 'No description available',
  'pages.meterialGraph.compositionNodes': 'Composition Nodes',
  'pages.meterialGraph.unknownNode': 'Unknown Node',
  'pages.meterialGraph.processNodes': 'Process Nodes',
  'pages.meterialGraph.performanceNodes': 'Performance Nodes',
  'pages.meterialGraph.environmentNodes': 'Environment Nodes',
  'pages.meterialGraph.loadingSystemInfo': 'System information loading...',
  'pages.meterialGraph.systemQueryAnalysis': 'System Query and Analysis',
  'pages.meterialGraph.systemCompare': 'System Comparison',
  'pages.meterialGraph.systemCompareDesc': 'Select different systems to view their composition-process-performance relationship differences',
  'pages.meterialGraph.multiQuery': 'Multi-dimensional Query',
  'pages.meterialGraph.multiQueryDesc': 'Supports cross-system queries, such as: "What is the thermal conductivity value of chloride salt systems at 850°C?"',
  'pages.meterialGraph.knowledgeGraphQuery': 'Knowledge Graph Query',
  'pages.meterialGraph.queryPlaceholder': 'Query, e.g.: "What is the thermal conductivity value of chloride salt systems at 850°C?"',
  'pages.meterialGraph.query': 'Query',
  'pages.meterialGraph.queryResult': 'Query Result:',
  'pages.meterialGraph.relatedSystems': 'Related Systems',
  'pages.meterialGraph.emptyQueryDesc': 'Please enter query content and click the query button to get results',
  // PropertiesGrouper
  'pages.propertiesGrouper.title': 'Eutectic Salt Screening',
  'pages.propertiesGrouper.saltSystem': 'Salt System Composition',
  'pages.propertiesGrouper.saltSystem.label': 'Salt System Composition *',
  'pages.propertiesGrouper.saltSystem.required': 'Please enter salt system composition',
  'pages.propertiesGrouper.saltSystem.extra': 'Supported formats: LiF-BeF2 45-55 mol% or direct input LiF-BeF2',
  'pages.propertiesGrouper.saltSystem.placeholder': 'e.g.: LiF-BeF2 45-55 mol%',
  'pages.propertiesGrouper.analysisType.label': 'Analysis Type *',
  'pages.propertiesGrouper.analysisType.required': 'Please select analysis type',
  'pages.propertiesGrouper.analysisType.placeholder': 'Please select analysis type',
  'pages.propertiesGrouper.classification': 'Classification: Predict salt system categories (stable/unstable, corrosion level)',
  'pages.propertiesGrouper.clustering': 'Clustering: Cluster multi-component salts based on property similarity',
  'pages.propertiesGrouper.analysisMethod.label': 'Analysis Method (Optional)',
  'pages.propertiesGrouper.analysisMethod.extra': 'Optional, default method will be used if not selected',
  'pages.propertiesGrouper.analysisMethod.placeholder': 'Please select analysis method (optional)',
  'pages.propertiesGrouper.start': 'Start Screening',
  'pages.propertiesGrouper.reset': 'Reset',
  'pages.propertiesGrouper.success': 'Screening successful',
  'pages.propertiesGrouper.failure': 'Screening failed, please try again',
  'pages.propertiesGrouper.tip': 'Operation Tips',
  'pages.propertiesGrouper.tip.description': 'Please fill in screening parameters on the left, then click the "Start Screening" button',
  // DigResult Details Additional Translations
  'pages.digResult.details.comparisonAnalysis': 'Comparative Analysis Details',
  'pages.digResult.details.physicalPropertyComparison': 'Physical Property Comparison Analysis',
  'pages.digResult.details.detailedDataTable': 'Detailed Data Table',
  'pages.digResult.details.dataAnalysisInsight': 'Data Analysis & Insights',
  'pages.digResult.details.physicalTrendAnalysis': 'Physical Property Trend Analysis',
  'pages.digResult.details.applicationRecommendation': 'Application Recommendations',
  'pages.digResult.details.selectPhysicalParams': 'Select Physical Parameters',
  'pages.digResult.details.temperatureRange': 'Temperature Range',
  'pages.digResult.details.dataSource': 'Data Source',
  'pages.digResult.details.allDataSources': 'All Data Sources',
  'pages.digResult.details.updateChart': 'Update Chart',
  'pages.digResult.details.temperature': 'Temperature',
  'pages.digResult.details.physicalType': 'Physical Property Type',
  'pages.digResult.details.physicalValue': 'Physical Property Value',
  'pages.digResult.details.dataSourceName': 'Data Source',
  'pages.digResult.details.systemParamRequired': 'System parameter cannot be empty',
  'pages.digResult.details.loadChartDataFailed': 'Failed to load chart data, please try again later',
  'pages.digResult.details.noChartData': 'No chart data available',
  'pages.digResult.details.dataVolume': 'Data Volume',
  'pages.digResult.details.basedOnPhysicalData': 'Based on physical property data analysis',
  'pages.digResult.details.physicalPropertyVsTemp': 'Physical Property Parameters vs Temperature Curve',
  'pages.digResult.details.temperatureUnit': 'Temperature(℃)',
  'pages.digResult.details.physicalValueLabel': 'Physical Property Value',
  'pages.digResult.details.multiPhysicalVsTemp': 'Multi-Physical Properties vs Temperature Curve',
  'pages.digResult.details.multiPhysicalComparison': 'Multi-Physical Properties Comparison Analysis',
  'pages.digResult.details.unknown': 'Unknown',
  'pages.digResult.details.fittingCurve': 'Fitting Curve',
  'pages.digResult.details.physicalTrendAnalysisTitle': 'Physical Property Trend Analysis',
  // FaultDetection main page
  'pages.faultDetection.title': 'Anomaly Detection Task List',
  'pages.faultDetection.taskName': 'Task Name',
  'pages.faultDetection.dataSource': 'Data Source',
  'pages.faultDetection.detectionMethod': 'Detection Method',
  'pages.faultDetection.taskStatus': 'Task Status',
  'pages.faultDetection.physicalType': 'Physical Property Type',
  'pages.faultDetection.totalRecords': 'Total Records',
  'pages.faultDetection.anomalyCount': 'Anomaly Count',
  'pages.faultDetection.createTime': 'Create Time',
  'pages.faultDetection.operation': 'Operation',
  'pages.faultDetection.all': 'All',
  'pages.faultDetection.taskId': 'Task ID',
  'pages.faultDetection.detail': 'Detail',
  'pages.faultDetection.edit': 'Edit',
  'pages.faultDetection.delete': 'Delete',
  'pages.faultDetection.add': 'Add',
  'pages.faultDetection.total': 'Total {total} items',
  'pages.faultDetection.taskIdNotFound': 'Task ID does not exist, cannot view details',
  'pages.faultDetection.taskIdNotFoundEdit': 'Task ID does not exist, cannot edit',
  'pages.faultDetection.taskIdNotFoundDelete': 'Task ID does not exist, cannot delete',
  'pages.faultDetection.deleteSuccess': 'Delete successful',
  'pages.faultDetection.deleteFailure': 'Delete failed',
  'pages.faultDetection.deleteConfirm': 'Are you sure you want to delete this task?',
  'pages.faultDetection.confirm': 'Confirm',
  'pages.faultDetection.cancel': 'Cancel',
  // DetailsModal additional translations
  'pages.faultDetection.taskDetails': 'Task Details',
  'pages.faultDetection.taskInfo': 'Task Information',
  'pages.faultDetection.finishTime': 'Finish Time',
  'pages.faultDetection.detectionStatistics': 'Detection Statistics',
  'pages.faultDetection.normalCount': 'Normal Count',
  'pages.faultDetection.anomalyRate': 'Anomaly Rate',
  'pages.faultDetection.averageAnomalyScore': 'Average Anomaly Score',
  'pages.faultDetection.anomalyDetectionResults': 'Anomaly Detection Results',
  'pages.faultDetection.unknownType': 'Unknown Type',
  'pages.faultDetection.notReviewed': 'Not Reviewed',
  'pages.faultDetection.recordId': 'Record ID',
  'pages.faultDetection.anomalyReason': 'Anomaly Reason',
  'pages.faultDetection.anomalyStatus': 'Anomaly Status',
  'pages.faultDetection.detectionDetails': 'Detection Details',
  'pages.faultDetection.reviewComment': 'Review Comment',
  'pages.faultDetection.noAnomalyResults': 'No anomaly detection results available',
  'pages.faultDetection.anomalyType': 'Anomaly Type',
  'pages.faultDetection.reviewAction': 'Review Action',
  'pages.faultDetection.reviewCommentOptional': 'Review Comment (Optional)',
  'pages.faultDetection.enterReviewComment': 'Please enter review comment',
  'pages.faultDetection.selectReviewAction': 'Please select review action',
  'pages.faultDetection.reviewSubmitted': 'Review submitted successfully',
  'pages.faultDetection.reviewSubmitFailed': 'Review submission failed',
  'pages.faultDetection.reviewSubmitFailedRetry': 'Review submission failed, please try again',
  'pages.faultDetection.getDataFailed': 'Failed to get data, please try again',
  // FaultDetection additional translations
  'pages.faultDetection.createTaskModalTitle': 'Create Anomaly Detection Task',
  'pages.faultDetection.editTaskModalTitle': 'Edit Anomaly Detection Task',
  'pages.faultDetection.getTaskDetailFailed': 'Failed to get task details',
  'pages.faultDetection.getTaskDetailFailedRetry': 'Failed to get task details, please try again',
  'pages.faultDetection.taskIdNotFoundUpdate': 'Task ID does not exist, cannot update',
  'pages.faultDetection.detectionParamsFormatError': 'Detection parameter format error, please enter valid JSON format',
  'pages.faultDetection.updateSuccess': 'Update task successful',
  'pages.faultDetection.updateFailed': 'Update task failed',
  'pages.faultDetection.updateFailedRetry': 'Update task failed, please try again',
  'pages.faultDetection.selectDetectionMethodFirst': 'Please select detection method first',
  'pages.faultDetection.zScoreParamsExample': 'Z-score method threshold, default 3.0. Example: {"threshold": 3.0}',
  'pages.faultDetection.iqrParamsExample': 'IQR method multiplier, default 1.5. Example: {"multiplier": 1.5}',
  'pages.faultDetection.autoencoderParamsExample': 'Autoencoder threshold, default 0.5. Example: {"threshold": 0.5}',
  'pages.faultDetection.inputJsonFormatParams': 'Please enter detection parameters in JSON format',
  'pages.faultDetection.taskNamePlaceholder': 'Please enter task name',
  'pages.faultDetection.dataSourcePlaceholder': 'Please select data source',
  'pages.faultDetection.detectionMethodPlaceholder': 'Please select detection method',
  'pages.faultDetection.detectionParamsLabel': 'Detection Parameters (JSON format)',
  'pages.faultDetection.detectionParamsPlaceholder': 'Please enter JSON format detection parameters, e.g.: {"threshold": 0.5}',
  'pages.faultDetection.physicalTypePlaceholder': 'Please select physical property type (optional)',
  'pages.faultDetection.physicalUnit': 'Physical Property Unit',
  'pages.faultDetection.physicalUnitPlaceholder': 'Please select physical property unit (optional)',
  'pages.faultDetection.tempUnit': 'Temperature Unit',
  'pages.faultDetection.tempUnitPlaceholder': 'Please select temperature unit (optional)',
  'pages.faultDetection.filterCondition': 'Filter Condition',
  'pages.faultDetection.filterConditionExtra': 'Optional, e.g.: LiF-BeF2',
  'pages.faultDetection.filterConditionPlaceholder': 'Please enter filter condition (optional)',
  'pages.faultDetection.recordIdsLabel': 'Record IDs List',
  'pages.faultDetection.recordIdsExtra': 'Optional, multiple IDs separated by commas, e.g.: 1,2,3. No input means all data will be detected.',
  'pages.faultDetection.recordIdsPlaceholder': 'Please enter record IDs, multiple IDs separated by commas (optional)',
  'pages.faultDetection.submit': 'Submit',
  'pages.faultDetection.update': 'Update',
  // Dynamic Periodic Table
  'pages.dynamicPeriodic.atomicNumber': 'Atomic Number',
  'pages.dynamicPeriodic.atomicMass': 'Atomic Mass',
  'pages.dynamicPeriodic.electronConfig': 'Electron Configuration',
  'pages.dynamicPeriodic.discoveredBy': 'Discovered By',
  'pages.dynamicPeriodic.unknown': 'Unknown',
  'pages.dynamicPeriodic.category': 'Category',
  'pages.dynamicPeriodic.preview': 'Preview',
  'pages.dynamicPeriodic.wikipediaLink': 'Wikipedia Link',
  'pages.dynamicPeriodic.bohrModel': 'Bohr Model',
  'pages.dynamicPeriodic.bohrModelAlt': '{name} Bohr Model',
  'pages.dynamicPeriodic.electronTable': 'Standard Atomic Electron Count',
  'pages.dynamicPeriodic.electronShell': 'Electron Shell',
  'pages.dynamicPeriodic.orbitalElectrons': '{orbital} Orbital Electrons',
  'pages.dynamicPeriodic.clickToView': 'Click on element to view details',
  // Data Upload Edit Table
  'pages.dataUpload.editTable.index': 'Index',
  'pages.dataUpload.editTable.component': 'Component',
  'pages.dataUpload.editTable.coefficient': 'Coefficient',
  'pages.dataUpload.editTable.experimentDataInfo': 'Experiment Data Information',
  'pages.dataUpload.editTable.system': 'System',
  'pages.dataUpload.editTable.physicalType': 'Physical Type',
  'pages.dataUpload.editTable.dataSource': 'Data Source',
  'pages.dataUpload.editTable.physicalUnit': 'Physical Unit',
  'pages.dataUpload.editTable.tempVerifyValue': 'Temperature Verification Value',
  'pages.dataUpload.editTable.tempUnit': 'Temperature Unit',
  'pages.dataUpload.editTable.detail': 'Detail',
  'pages.dataUpload.editTable.viewDetail': 'View Detail',
  'pages.dataUpload.editTable.experimentDataDetail': 'Experiment Data Detail',
  'pages.dataUpload.editTable.cancel': 'Cancel',
  'pages.dataUpload.editTable.save': 'Save',
  'pages.dataUpload.editTable.modify': 'Modify',
  'pages.dataUpload.editTable.confirm': 'Confirm',
  'pages.dataUpload.editTable.pleaseSelectPhysicalUnit': 'Please select physical unit',
  'pages.dataUpload.editTable.pleaseSelectTempUnit': 'Please select temperature unit',
  'pages.dataUpload.editTable.importFileFormat': 'Import File Format',
  'pages.dataUpload.editTable.standardExcelFormat': 'Standard Excel Format',
  'pages.dataUpload.editTable.pageNumber': 'Page Number',
  'pages.dataUpload.editTable.docYear': 'Document Year',
  'pages.dataUpload.editTable.docTitle': 'Document Title',
  'pages.dataUpload.editTable.docKeyword': 'Document Keyword',
  'pages.dataUpload.editTable.docAbstract': 'Document Abstract',
  'pages.dataUpload.editTable.importFile': 'Import File',
  'pages.dataUpload.editTable.pleaseInputCoefficient': 'Please input coefficient',
  'pages.dataUpload.editTable.measuredValue': 'Measured Value',
  'pages.dataUpload.editTable.temperature': 'Temperature',
  'pages.dataUpload.editTable.unitConversion': 'Unit Conversion',
  'pages.dataUpload.editTable.convert': 'Convert',
  // Data Import Edit Table
  'pages.dataImport.editTable.index': 'Index',
  'pages.dataImport.editTable.component': 'Component',
  'pages.dataImport.editTable.coefficient': 'Coefficient',
  'pages.dataImport.editTable.experimentDataInfo': 'Experiment Data Information',
  'pages.dataImport.editTable.system': 'System',
  'pages.dataImport.editTable.physicalType': 'Physical Type',
  'pages.dataImport.editTable.dataSource': 'Data Source',
  'pages.dataImport.editTable.physicalUnit': 'Physical Unit',
  'pages.dataImport.editTable.tempVerifyValue': 'Temperature Verification Value',
  'pages.dataImport.editTable.tempUnit': 'Temperature Unit',
  'pages.dataImport.editTable.detail': 'Detail',
  'pages.dataImport.editTable.viewDetail': 'View Detail',
  'pages.dataImport.editTable.simulationDataDetail': 'Simulation Data Detail',
  'pages.dataImport.editTable.cancel': 'Cancel',
  'pages.dataImport.editTable.save': 'Save',
  'pages.dataImport.editTable.modify': 'Modify',
  'pages.dataImport.editTable.confirm': 'Confirm',
  'pages.dataImport.editTable.pleaseSelectPhysicalUnit': 'Please select physical unit',
  'pages.dataImport.editTable.pleaseSelectTempUnit': 'Please select temperature unit',
  'pages.dataImport.editTable.importFileFormat': 'Import File Format',
  'pages.dataImport.editTable.standardExcelFormat': 'Standard Excel Format',
  'pages.dataImport.editTable.importFile': 'Import File',
  'pages.dataImport.editTable.measuredValue': 'Measured Value',
  'pages.dataImport.editTable.temperature': 'Temperature',
  // Data Upload Upload
  'pages.dataUpload.importData': 'Import Data',
  'pages.dataUpload.format': 'Format',
  'pages.dataUpload.standardFormat': 'Standard Format(Excel/CSV)',
  'pages.dataUpload.instrumentData': 'Professional Instrument Raw Data(CSV)',
  'pages.dataUpload.physicalType': 'Physical Type',
  'pages.dataUpload.all': 'All',
  'pages.dataUpload.density': 'Density',
  'pages.dataUpload.viscosity': 'Viscosity',
  'pages.dataUpload.specificHeat': 'Specific Heat',
  'pages.dataUpload.thermalConductivity': 'Thermal Conductivity',
  'pages.dataUpload.electricalConductivity': 'Electrical Conductivity',
  'pages.dataUpload.thermalExpansion': 'Thermal Expansion',
  'pages.dataUpload.data': 'Data',
  'pages.dataUpload.meltingPoint': 'Melting Point',
  'pages.dataUpload.boilingPoint': 'Boiling Point',
  'pages.dataUpload.meltingEnthalpy': 'Melting Enthalpy',
  'pages.dataUpload.surfaceTension': 'Surface Tension',
  'pages.dataUpload.contactAngle': 'Contact Angle',
  'pages.dataUpload.thermalWeightLoss': 'Thermal Weight Loss',
  'pages.dataUpload.vaporPressure': 'Vapor Pressure',
  'pages.dataUpload.experimentCondition': 'Experiment Condition',
  'pages.dataUpload.sampleSize': 'Sample Size',
  'pages.dataUpload.testDate': 'Test Date',
  'pages.dataUpload.testPerson': 'Test Person',
  'pages.dataUpload.testingAgency': 'Testing Agency',
  'pages.dataUpload.importData': 'Import Data',
  'pages.dataUpload.component': 'Component',
  'pages.dataUpload.percentage': 'Percentage',
  'pages.dataUpload.missingComponent': 'Missing Component',
  'pages.dataUpload.missingPercentage': 'Missing Percentage',
  'pages.dataUpload.uploadText': 'Click or drag file to area to upload automatically',
  'pages.dataUpload.uploadHint': 'Support single file upload, can upload single file multiple times, please check template for specific file upload format',
  // Data Upload Add
  'pages.dataUpload.add.materialData': 'Material Data',
  'pages.dataUpload.add.component': 'Component',
  'pages.dataUpload.add.pleaseInputComponent': 'Please input component',
  'pages.dataUpload.add.proportion': 'Proportion',
  'pages.dataUpload.add.pleaseInputProportion': 'Please input proportion',
  'pages.dataUpload.add.pleaseSelectPhysicalType': 'Please select physical type',
  'pages.dataUpload.add.pleaseSelectPhysicalUnit': 'Please select physical unit',
  'pages.dataUpload.add.pleaseInputDataSource': 'Please input data source',
  'pages.dataUpload.add.pleaseInputTTmin': 'Please input T/Tmin',
  'pages.dataUpload.add.pleaseInputTmax': 'Please input Tmax',
  'pages.dataUpload.add.pleaseSelectTempUnit': 'Please select temperature unit',
  'pages.dataUpload.add.coefficient': 'Coefficient',
  'pages.dataUpload.add.pleaseInputCoefficient': 'Please input coefficient',
  'pages.dataUpload.add.physicalData': 'Physical Data',
  'pages.dataUpload.add.meltingPoint': 'Melting Point',
  'pages.dataUpload.add.pleaseInputMeltingPoint': 'Please input melting point',
  'pages.dataUpload.add.boilingPoint': 'Boiling Point',
  'pages.dataUpload.add.pleaseInputBoilingPoint': 'Please input boiling point',
  'pages.dataUpload.add.meltingHan': 'Melting Enthalpy',
  'pages.dataUpload.add.pleaseInputMeltingHan': 'Please input melting enthalpy',
  'pages.dataUpload.add.surfaceTension': 'Surface Tension',
  'pages.dataUpload.add.pleaseInputSurfaceTension': 'Please input surface tension',
  'pages.dataUpload.add.contactAngle': 'Contact Angle',
  'pages.dataUpload.add.pleaseInputContactAngle': 'Please input contact angle',
  'pages.dataUpload.add.tga': 'Thermal Weight Loss',
  'pages.dataUpload.add.pleaseInputTga': 'Please input thermal weight loss',
  'pages.dataUpload.add.vaporPressure': 'Vapor Pressure',
  'pages.dataUpload.add.pleaseInputVaporPressure': 'Please input vapor pressure',
  'pages.dataUpload.add.chemicalData': 'Chemical Data',
  'pages.dataUpload.add.corrosive': 'Corrosive',
  'pages.dataUpload.add.pleaseInputCorrosive': 'Please input corrosive',
  'pages.dataUpload.add.corrosionPotential': 'Corrosion Potential',
  'pages.dataUpload.add.pleaseInputCorrosionPotential': 'Please input corrosion potential',
  'pages.dataUpload.add.thermalStabilityWindow': 'Thermal Stability Window',
  'pages.dataUpload.add.pleaseFillThermalStabilityWindow': 'Please fill thermal stability window',
  'pages.dataUpload.add.minValue': 'Minimum Value',
  'pages.dataUpload.add.pleaseInputMinValue': 'Please input minimum value',
  'pages.dataUpload.add.maxValue': 'Maximum Value',
  'pages.dataUpload.add.pleaseInputMaxValue': 'Please input maximum value',
  'pages.dataUpload.add.electrochemistryWindow': 'Electrochemistry Window',
  'pages.dataUpload.add.pleaseFillElectrochemistryWindow': 'Please fill electrochemistry window',
  'pages.dataUpload.add.experimentCondition': 'Experiment Condition',
  'pages.dataUpload.add.sampleSize': 'Sample Size',
  'pages.dataUpload.add.pleaseInputSampleSize': 'Please input sample size',
  'pages.dataUpload.add.testTime': 'Test Date',
  'pages.dataUpload.add.atmosphere': 'Atmosphere',
  'pages.dataUpload.add.pleaseInputAtmosphere': 'Please input atmosphere',
  'pages.dataUpload.add.impurityConcentration': 'Impurity Concentration',
  'pages.dataUpload.add.pleaseInputImpurityConcentration': 'Please input impurity concentration',
  'pages.dataUpload.add.testPerson': 'Test Person',
  'pages.dataUpload.add.pleaseInputTestPerson': 'Please input test person',
  'pages.dataUpload.add.testingAgency': 'Testing Agency',
  'pages.dataUpload.add.pleaseInputTestingAgency': 'Please input testing agency',
  'pages.dataUpload.add.approvalId': 'Approval Person',
  'pages.dataUpload.add.pleaseSelectApprovalId': 'Please select approval person',
  'pages.dataUpload.add.docDoi': 'DOI',
  'pages.dataUpload.add.docPage': 'Page Number',
  'pages.dataUpload.add.pleaseInputDocPage': 'Please input page number',
  'pages.dataUpload.add.docYear': 'Year',
  'pages.dataUpload.add.docTitle': 'Document Title',
  'pages.dataUpload.add.pleaseInputDocTitle': 'Please input document title',
  'pages.dataUpload.add.docKeyword': 'Document Keyword',
  'pages.dataUpload.add.pleaseInputDocKeyword': 'Please input document keyword',
  'pages.dataUpload.add.docAbstract': 'Document Abstract',
  'pages.dataUpload.add.pleaseInputDocAbstract': 'Please input document abstract',
  'pages.dataUpload.add.confirmSubmit': 'Confirm Submit',
  // Data Upload Batch Add
  'pages.dataUpload.batchAdd.selectFileTypeFirst': 'Please select file type first',
  'pages.dataUpload.batchAdd.fileFormatIncorrect': 'File format is incorrect',
  'pages.dataUpload.batchAdd.fileUploadSuccess': '{fileName} uploaded successfully',
  'pages.dataUpload.batchAdd.dataProcessSuccess': 'Data processing successful',
  'pages.dataUpload.batchAdd.dataProcessFailed': 'Data processing failed',
  'pages.dataUpload.batchAdd.processDataFailed': 'Failed to process data',
  'pages.dataUpload.batchAdd.fileUploadFailed': '{fileName} upload failed',
  'pages.dataUpload.batchAdd.uploadFailed': '{fileName} upload failed',
  'pages.dataUpload.batchAdd.selectFormatFirst': 'Please select format first',
  'pages.dataUpload.batchAdd.unsupportedFormat': 'Unsupported format',
  'pages.dataUpload.batchAdd.importTemplate': 'Import Template',
  'pages.dataUpload.batchAdd.templateDownloadSuccess': 'Template download successful',
  'pages.dataUpload.batchAdd.templateDownloadFailed': 'Template download failed',
  'pages.dataUpload.batchAdd.templateDownloadFailedRetry': 'Template download failed, please retry',
  'pages.dataUpload.batchAdd.reportBathIdRequired': 'Report batch ID is required',
  'pages.dataUpload.batchAdd.physicalData': 'Physical Data',
  'pages.dataUpload.batchAdd.meltingPoint': 'Melting Point',
  'pages.dataUpload.batchAdd.meltingPointRequired': 'Please input melting point',
  'pages.dataUpload.batchAdd.meltingPointPlaceholder': 'Please input melting point',
  'pages.dataUpload.batchAdd.boilingPoint': 'Boiling Point',
  'pages.dataUpload.batchAdd.boilingPointRequired': 'Please input boiling point',
  'pages.dataUpload.batchAdd.boilingPointPlaceholder': 'Please input boiling point',
  'pages.dataUpload.batchAdd.meltingEnthalpy': 'Melting Enthalpy',
  'pages.dataUpload.batchAdd.meltingEnthalpyPlaceholder': 'Please input melting enthalpy',
  'pages.dataUpload.batchAdd.surfaceTension': 'Surface Tension',
  'pages.dataUpload.batchAdd.surfaceTensionPlaceholder': 'Please input surface tension',
  'pages.dataUpload.batchAdd.contactAngle': 'Contact Angle',
  'pages.dataUpload.batchAdd.contactAnglePlaceholder': 'Please input contact angle',
  'pages.dataUpload.batchAdd.thermalWeightLoss': 'Thermal Weight Loss',
  'pages.dataUpload.batchAdd.thermalWeightLossPlaceholder': 'Please input thermal weight loss',
  'pages.dataUpload.batchAdd.vaporPressure': 'Vapor Pressure',
  'pages.dataUpload.batchAdd.vaporPressurePlaceholder': 'Please input vapor pressure',
  'pages.dataUpload.batchAdd.chemicalData': 'Chemical Data',
  'pages.dataUpload.batchAdd.corrosive': 'Corrosive',
  'pages.dataUpload.batchAdd.corrosiveRequired': 'Please input corrosive',
  'pages.dataUpload.batchAdd.corrosivePlaceholder': 'Please input corrosive',
  'pages.dataUpload.batchAdd.corrosionPotential': 'Corrosion Potential',
  'pages.dataUpload.batchAdd.corrosionPotentialRequired': 'Please input corrosion potential',
  'pages.dataUpload.batchAdd.corrosionPotentialPlaceholder': 'Please input corrosion potential',
  'pages.dataUpload.batchAdd.thermalStabilityWindow': 'Thermal Stability Window',
  'pages.dataUpload.batchAdd.thermalStabilityWindowRequired': 'Please fill thermal stability window',
  'pages.dataUpload.batchAdd.minValue': 'Minimum Value',
  'pages.dataUpload.batchAdd.minValueRequired': 'Please input minimum value',
  'pages.dataUpload.batchAdd.maxValue': 'Maximum Value',
  'pages.dataUpload.batchAdd.maxValueRequired': 'Please input maximum value',
  'pages.dataUpload.batchAdd.electrochemistryWindow': 'Electrochemistry Window',
  'pages.dataUpload.batchAdd.electrochemistryWindowRequired': 'Please fill electrochemistry window',
  'pages.dataUpload.batchAdd.experimentCondition': 'Experiment Condition',
  'pages.dataUpload.batchAdd.sampleSize': 'Sample Size',
  'pages.dataUpload.batchAdd.sampleSizePlaceholder': 'Please input sample size',
  'pages.dataUpload.batchAdd.testDate': 'Test Date',
  'pages.dataUpload.batchAdd.atmosphere': 'Atmosphere',
  'pages.dataUpload.batchAdd.atmospherePlaceholder': 'Please input atmosphere',
  'pages.dataUpload.batchAdd.impurityConcentration': 'Impurity Concentration',
  'pages.dataUpload.batchAdd.impurityConcentrationPlaceholder': 'Please input impurity concentration',
  'pages.dataUpload.batchAdd.testPerson': 'Test Person',
  'pages.dataUpload.batchAdd.testPersonPlaceholder': 'Please input test person',
  'pages.dataUpload.batchAdd.testingAgency': 'Testing Agency',
  'pages.dataUpload.batchAdd.testingAgencyPlaceholder': 'Please input testing agency',
  'pages.dataUpload.batchAdd.approvalPerson': 'Approval Person',
  'pages.dataUpload.batchAdd.approvalPersonRequired': 'Please select approval person',
  'pages.dataUpload.batchAdd.approvalPersonPlaceholder': 'Please select approval person',
  'pages.dataUpload.batchAdd.importData': 'Import Data',
  'pages.dataUpload.batchAdd.format': 'Format',
  'pages.dataUpload.batchAdd.formatRequired': 'Please select format',
  'pages.dataUpload.batchAdd.formatPlaceholder': 'Please select format',
  'pages.dataUpload.batchAdd.downloadTemplate': 'Download Template',
  'pages.dataUpload.batchAdd.downloadTemplateTooltip': 'Download import template',
  'pages.dataUpload.batchAdd.selectFormatFirstTooltip': 'Please select format first',
  'pages.dataUpload.batchAdd.physicalType': 'Physical Type',
  'pages.dataUpload.batchAdd.physicalTypeRequired': 'Please select physical type',
  'pages.dataUpload.batchAdd.physicalTypePlaceholder': 'Please select physical type',
  'pages.dataUpload.batchAdd.component': 'Component',
  'pages.dataUpload.batchAdd.componentRequired': 'Please input component',
  'pages.dataUpload.batchAdd.componentPlaceholder': 'Please input component',
  'pages.dataUpload.batchAdd.percentage': 'Percentage',
  'pages.dataUpload.batchAdd.percentageRequired': 'Please input percentage',
  'pages.dataUpload.batchAdd.percentagePlaceholder': 'Please input percentage',
  'pages.dataUpload.batchAdd.dataPreview': 'Data Preview',
  'pages.dataUpload.batchAdd.submit': 'Submit',
  // Data Upload Record
  'pages.dataUpload.record.createUser': 'Create User',
  'pages.dataUpload.record.createType': 'Create Type',
  'pages.dataUpload.record.status': 'Status',
  'pages.dataUpload.record.createTime': 'Create Time',
  'pages.dataUpload.record.dataSource': 'Data Source',
  'pages.dataUpload.record.dataCount': 'Data Count (items)',
  'pages.dataUpload.record.approvalName': 'Approval Person',
  'pages.dataUpload.record.sourceFile': 'Source File',
  'pages.dataUpload.record.approvalOpinion': 'Approval Opinion',
  'pages.dataUpload.record.operation': 'Operation',
  'pages.dataUpload.record.approve': 'Approve',
  'pages.dataUpload.record.approvalResult': 'Approval Result',
  'pages.dataUpload.record.edit': 'Edit',
  'pages.dataUpload.record.importRecordList': 'Import Record List',
  // Data Import Batch Add
  'pages.dataImport.batchAdd.excelOnly': 'Only Excel format files are supported for upload!',
  'pages.dataImport.batchAdd.dataParseSuccess': 'Data parsing successful!',
  'pages.dataImport.batchAdd.dataParseFailed': 'Data parsing failed!',
  'pages.dataImport.batchAdd.fileUploadSuccess': '{fileName} uploaded successfully!',
  'pages.dataImport.batchAdd.fileUploadFailed': '{fileName} upload failed!',
  'pages.dataImport.batchAdd.uploadFailed': '{fileName} upload failed!',
  'pages.dataImport.batchAdd.simulationTemplateName': 'Simulation Calculation Results Batch Import Template.xlsx',
  'pages.dataImport.batchAdd.templateDownloadSuccess': 'Template download successful',
  'pages.dataImport.batchAdd.templateDownloadFailed': 'Template download failed',
  'pages.dataImport.batchAdd.templateDownloadFailedRetry': 'Template download failed, please retry',
  'pages.dataImport.batchAdd.uploadAndParseFirst': 'Please upload and parse the data file first!',
  'pages.dataImport.batchAdd.updateSuccess': 'Update successful',
  'pages.dataImport.batchAdd.updateFailed': 'Update failed',
  'pages.dataImport.batchAdd.submitSuccess': 'Submit successful',
  'pages.dataImport.batchAdd.submitFailed': 'Submit failed',
  'pages.dataImport.batchAdd.physicalData': 'Physical Data',
  'pages.dataImport.batchAdd.meltingPointRequired': 'Please input melting point',
  'pages.dataImport.batchAdd.meltingPoint': 'Melting Point',
  'pages.dataImport.batchAdd.meltingPointPlaceholder': 'Please input melting point',
  'pages.dataImport.batchAdd.boilingPointRequired': 'Please input boiling point',
  'pages.dataImport.batchAdd.boilingPoint': 'Boiling Point',
  'pages.dataImport.batchAdd.boilingPointPlaceholder': 'Please input boiling point',
  'pages.dataImport.batchAdd.meltingEnthalpy': 'Melting Enthalpy',
  'pages.dataImport.batchAdd.meltingEnthalpyPlaceholder': 'Please input melting enthalpy',
  'pages.dataImport.batchAdd.surfaceTension': 'Surface Tension',
  'pages.dataImport.batchAdd.surfaceTensionPlaceholder': 'Please input surface tension',
  'pages.dataImport.batchAdd.contactAngle': 'Contact Angle',
  'pages.dataImport.batchAdd.contactAnglePlaceholder': 'Please input contact angle',
  'pages.dataImport.batchAdd.thermalWeightLoss': 'Thermal Weight Loss',
  'pages.dataImport.batchAdd.thermalWeightLossPlaceholder': 'Please input thermal weight loss',
  'pages.dataImport.batchAdd.vaporPressure': 'Vapor Pressure',
  'pages.dataImport.batchAdd.vaporPressurePlaceholder': 'Please input vapor pressure',
  'pages.dataImport.batchAdd.chemicalData': 'Chemical Data',
  'pages.dataImport.batchAdd.corrosive': 'Corrosive',
  'pages.dataImport.batchAdd.corrosiveRequired': 'Please input corrosive',
  'pages.dataImport.batchAdd.corrosivePlaceholder': 'Please input corrosive',
  'pages.dataImport.batchAdd.corrosionPotential': 'Corrosion Potential',
  'pages.dataImport.batchAdd.corrosionPotentialRequired': 'Please input corrosion potential',
  'pages.dataImport.batchAdd.corrosionPotentialPlaceholder': 'Please input corrosion potential',
  'pages.dataImport.batchAdd.thermalStabilityWindow': 'Thermal Stability Window',
  'pages.dataImport.batchAdd.thermalStabilityWindowRequired': 'Please fill thermal stability window',
  'pages.dataImport.batchAdd.minValueRequired': 'Please input minimum value',
  'pages.dataImport.batchAdd.minValue': 'Minimum Value',
  'pages.dataImport.batchAdd.maxValueRequired': 'Please input maximum value',
  'pages.dataImport.batchAdd.maxValue': 'Maximum Value',
  'pages.dataImport.batchAdd.electrochemistryWindow': 'Electrochemistry Window',
  'pages.dataImport.batchAdd.electrochemistryWindowRequired': 'Please fill electrochemistry window',
  'pages.dataImport.batchAdd.experimentCondition': 'Experiment Condition',
  'pages.dataImport.batchAdd.sampleSize': 'Sample Size',
  'pages.dataImport.batchAdd.sampleSizePlaceholder': 'Please input sample size',
  'pages.dataImport.batchAdd.testDate': 'Test Date',
  'pages.dataImport.batchAdd.atmosphere': 'Atmosphere',
  'pages.dataImport.batchAdd.atmospherePlaceholder': 'Please input atmosphere',
  'pages.dataImport.batchAdd.impurityConcentration': 'Impurity Concentration',
  'pages.dataImport.batchAdd.impurityConcentrationPlaceholder': 'Please input impurity concentration',
  'pages.dataImport.batchAdd.testPerson': 'Test Person',
  'pages.dataImport.batchAdd.testPersonPlaceholder': 'Please input test person',
  'pages.dataImport.batchAdd.testingAgency': 'Testing Agency',
  'pages.dataImport.batchAdd.testingAgencyPlaceholder': 'Please input testing agency',
  'pages.dataImport.batchAdd.approvalPerson': 'Approval Person',
  'pages.dataImport.batchAdd.approvalPersonRequired': 'Please select approval person',
  'pages.dataImport.batchAdd.approvalPersonPlaceholder': 'Please select approval person',
  'pages.dataImport.batchAdd.machineLearningParams': 'Machine Learning Parameters',
  'pages.dataImport.batchAdd.simulationAlgorithm': 'Simulation Algorithm',
  'pages.dataImport.batchAdd.simulationAlgorithmRequired': 'Please select simulation algorithm',
  'pages.dataImport.batchAdd.simulationAlgorithmPlaceholder': 'Please select simulation algorithm',
  'pages.dataImport.add.potentialFunc': 'Potential Function',
  'pages.dataImport.add.potentialFuncPlaceholder': 'Please input potential function',
  'pages.dataImport.add.boxStepLength': 'Box Step Length',
  'pages.dataImport.add.boxStepLengthPlaceholder': 'Please input box step length',
  'pages.dataImport.add.boxSize': 'Box Size',
  'pages.dataImport.add.boxSizePlaceholder': 'Please input box size',
  'pages.dataImport.add.importData': 'Import Data',
  'pages.dataImport.batchAdd.downloadTemplate': 'Download Template',
  'pages.dataImport.batchAdd.downloadTemplateTooltip': 'Click to download the import template for the corresponding format',
  'pages.dataImport.batchAdd.uploadText': 'Click or drag file to area to upload automatically',
  'pages.dataImport.batchAdd.dataPreview': 'Data Preview',
  'pages.dataImport.batchAdd.submit': 'Submit',
  // Data Import Add
  'pages.dataImport.add.simulateBathIdRequired': 'Simulation batch ID cannot be empty',
  'pages.dataImport.add.atLeastOneCoefficient': 'Please input at least one coefficient',
  'pages.dataImport.add.tmaxRequired': 'Please input Tmax',
  'pages.dataImport.add.batchDataRequired': 'Please input batch data',
  'pages.dataImport.add.submitting': 'Submitting data, please wait...',
  'pages.dataImport.add.submitSuccess': 'Submit successful',
  'pages.dataImport.add.submitFailed': 'Submit failed, please retry',
  'pages.dataImport.add.submit': 'Submit',
  'pages.dataImport.add.materialData': 'Material Data',
  'pages.dataImport.add.component': 'Component',
  'pages.dataImport.add.componentRequired': 'Please input component',
  'pages.dataImport.add.componentPlaceholder': 'Please input component',
  'pages.dataImport.add.percentage': 'Percentage',
  'pages.dataImport.add.percentageRequired': 'Please input percentage',
  'pages.dataImport.add.percentagePlaceholder': 'Please input percentage',
  'pages.dataImport.add.physicalType': 'Physical Type',
  'pages.dataImport.add.physicalTypeRequired': 'Please select physical type',
  'pages.dataImport.add.physicalTypePlaceholder': 'Please select physical type',
  'pages.dataImport.add.physicalUnit': 'Physical Unit',
  'pages.dataImport.add.physicalUnitRequired': 'Please select physical unit',
  'pages.dataImport.add.selectPhysicalTypeFirst': 'Please select physical type first',
  'pages.dataImport.add.dataSource': 'Data Source',
  'pages.dataImport.add.dataSourceRequired': 'Please input data source',
  'pages.dataImport.add.dataSourcePlaceholder': 'Please input data source',
  'pages.dataImport.add.tTminRequired': 'Please input T/Tmin',
  'pages.dataImport.add.tTminPlaceholder': 'Please input T/Tmin',
  'pages.dataImport.add.tmaxRequired': 'Please input Tmax',
  'pages.dataImport.add.tmaxPlaceholder': 'Please input Tmax',
  'pages.dataImport.add.tempUnit': 'Temperature Unit',
  'pages.dataImport.add.tempUnitRequired': 'Please select temperature unit',
  'pages.dataImport.add.tempUnitPlaceholder': 'Please select temperature unit',
  'pages.dataImport.add.coefficientA': 'Coefficient a',
  'pages.dataImport.add.coefficientAPlaceholder': 'Please input coefficient a',
  'pages.dataImport.add.coefficientB': 'Coefficient b',
  'pages.dataImport.add.coefficientBPlaceholder': 'Please input coefficient b',
  'pages.dataImport.add.coefficientC': 'Coefficient c',
  'pages.dataImport.add.coefficientCPlaceholder': 'Please input coefficient c',
  'pages.dataImport.add.coefficientD': 'Coefficient d',
  'pages.dataImport.add.coefficientDPlaceholder': 'Please input coefficient d',
  'pages.dataImport.add.coefficientE': 'Coefficient e',
  'pages.dataImport.add.coefficientEPlaceholder': 'Please input coefficient e',
  'pages.dataImport.add.physicalData': 'Physical Data',
  'pages.dataImport.add.meltingPoint': 'Melting Point',
  'pages.dataImport.add.meltingPointPlaceholder': 'Please input melting point',
  'pages.dataImport.add.boilingPoint': 'Boiling Point',
  'pages.dataImport.add.boilingPointPlaceholder': 'Please input boiling point',
  'pages.dataImport.add.meltingEnthalpy': 'Melting Enthalpy',
  'pages.dataImport.add.meltingEnthalpyPlaceholder': 'Please input melting enthalpy',
  'pages.dataImport.add.surfaceTension': 'Surface Tension',
  'pages.dataImport.add.surfaceTensionPlaceholder': 'Please input surface tension',
  'pages.dataImport.add.contactAngle': 'Contact Angle',
  'pages.dataImport.add.contactAnglePlaceholder': 'Please input contact angle',
  'pages.dataImport.add.thermalWeightLoss': 'Thermal Weight Loss',
  'pages.dataImport.add.thermalWeightLossPlaceholder': 'Please input thermal weight loss',
  'pages.dataImport.add.vaporPressure': 'Vapor Pressure',
  'pages.dataImport.add.vaporPressurePlaceholder': 'Please input vapor pressure',
  'pages.dataImport.add.chemicalData': 'Chemical Data',
  'pages.dataImport.add.corrosive': 'Corrosive',
  'pages.dataImport.add.corrosiveRequired': 'Please input corrosive',
  'pages.dataImport.add.corrosivePlaceholder': 'Please input corrosive',
  'pages.dataImport.add.corrosionPotential': 'Corrosion Potential',
  'pages.dataImport.add.corrosionPotentialRequired': 'Please input corrosion potential',
  'pages.dataImport.add.corrosionPotentialPlaceholder': 'Please input corrosion potential',
  'pages.dataImport.add.thermalStabilityWindow': 'Thermal Stability Window',
  'pages.dataImport.add.thermalStabilityWindowRequired': 'Please fill thermal stability window',
  'pages.dataImport.add.minValueRequired': 'Please input minimum value',
  'pages.dataImport.add.minValue': 'Minimum Value',
  'pages.dataImport.add.maxValueRequired': 'Please input maximum value',
  'pages.dataImport.add.maxValue': 'Maximum Value',
  'pages.dataImport.add.electrochemistryWindow': 'Electrochemistry Window',
  'pages.dataImport.add.electrochemistryWindowRequired': 'Please fill electrochemistry window',
  'pages.dataImport.add.experimentCondition': 'Experiment Condition',
  'pages.dataImport.add.sampleSize': 'Sample Size',
  'pages.dataImport.add.sampleSizePlaceholder': 'Please input sample size',
  'pages.dataImport.add.testDate': 'Test Date',
  'pages.dataImport.add.atmosphere': 'Atmosphere',
  'pages.dataImport.add.atmospherePlaceholder': 'Please input atmosphere',
  'pages.dataImport.add.impurityConcentration': 'Impurity Concentration',
  'pages.dataImport.add.impurityConcentrationPlaceholder': 'Please input impurity concentration',
  'pages.dataImport.add.testPerson': 'Test Person',
  'pages.dataImport.add.testPersonPlaceholder': 'Please input test person',
  'pages.dataImport.add.testingAgency': 'Testing Agency',
  'pages.dataImport.add.testingAgencyPlaceholder': 'Please input testing agency',
  'pages.dataImport.add.approvalPerson': 'Approval Person',
  'pages.dataImport.add.approvalPersonRequired': 'Please select approval person',
  'pages.dataImport.add.approvalPersonPlaceholder': 'Please select approval person',
  'pages.dataImport.add.machineLearningParams': 'Machine Learning Parameters',
  'pages.dataImport.add.simulationAlgorithm': 'Simulation Algorithm',
  'pages.dataImport.add.simulationAlgorithmRequired': 'Please select simulation algorithm',
  'pages.dataImport.add.simulationAlgorithmPlaceholder': 'Please select simulation algorithm',
  // Data Upload Batch Add missing
  'pages.dataUpload.batchAdd.uploadText': 'Click or drag file to area to upload automatically',
  'pages.dataUpload.batchAdd.uploadHint': 'Support single file upload, can upload single file multiple times',
  // Data Import Mid Data Import
  'pages.dataImport.midDataImport.uploadFileFirst': 'Please upload file first!',
  'pages.dataImport.midDataImport.importSuccess': 'Mid data import successful!',
  'pages.dataImport.midDataImport.importFailed': 'Mid data import failed!',
  'pages.dataImport.midDataImport.system': 'System',
  'pages.dataImport.midDataImport.systemRequired': 'Please input system',
  'pages.dataImport.midDataImport.systemPlaceholder': 'Please input system',
  'pages.dataImport.midDataImport.mol': 'MOL',
  'pages.dataImport.midDataImport.molRequired': 'Please input mol ratio',
  'pages.dataImport.midDataImport.molPlaceholder': 'Please input MOL',
  'pages.dataImport.midDataImport.temp': 'Temperature',
  'pages.dataImport.midDataImport.tempRequired': 'Please input temperature',
  'pages.dataImport.midDataImport.tempPlaceholder': 'Please input temperature',
  'pages.dataImport.midDataImport.physicalType': 'Physical Type',
  'pages.dataImport.midDataImport.physicalTypeRequired': 'Please select physical type',
  'pages.dataImport.midDataImport.physicalTypePlaceholder': 'Please select physical type',
  'pages.dataImport.midDataImport.midData': 'Mid Data',
  'pages.dataImport.midDataImport.fileUploaded': 'File uploaded',
  'pages.dataImport.midDataImport.pleaseUploadFile': 'Please upload file',
  'pages.dataImport.midDataImport.uploadText': 'Click or drag file to area to upload automatically',
  'pages.dataImport.midDataImport.uploadHint': 'Support single file upload',
  'pages.dataImport.midDataImport.confirm': 'Confirm',
  'pages.dataImport.midDataImport.fileUploadSuccess': '{fileName} uploaded successfully!',
  'pages.dataImport.midDataImport.fileUploadFailed': '{fileName} upload failed!',
  'pages.dataImport.midDataImport.uploadFailed': '{fileName} upload failed!',
  // Data Import Record
  'pages.dataImport.all': 'All',
  'pages.dataImport.record.createTime': 'Create Time',
  'pages.dataImport.record.createUser': 'Creator',
  'pages.dataImport.record.createType': 'Create Type',
  'pages.dataImport.record.dataCount': 'Data Count',
  'pages.dataImport.record.status': 'Status',
  'pages.dataImport.record.sourceFile': 'Source File',
  'pages.dataImport.record.approvalOpinion': 'Approval Opinion',
  'pages.dataImport.record.operation': 'Operation',
  'pages.dataImport.record.approve': 'Approve',
  'pages.dataImport.record.approvalResult': 'Approval Result',
  'pages.dataImport.record.edit': 'Edit',
  'pages.dataImport.record.cannotGetBatchId': 'Cannot get batch ID',
  'pages.dataImport.record.detail': 'Detail',
  'pages.dataImport.record.tTmin': 'T/Tmin',
  'pages.dataImport.record.tmax': 'Tmax',
  'pages.dataImport.record.importRecordList': 'Import Record List',
  // Details Modal
  'pages.dataImport.record.simulationDataInfo': 'Simulation Data Information',
  'pages.dataImport.record.system': 'System',
  'pages.dataImport.record.physicalType': 'Physical Type',
  'pages.dataImport.record.physicalUnit': 'Physical Unit',
  'pages.dataImport.record.dataSource': 'Data Source',
  'pages.dataImport.record.tempUnit': 'Temperature Unit',
  'pages.dataImport.record.algorithm': 'Algorithm',
  'pages.dataImport.record.index': 'Index',
  'pages.dataImport.record.component': 'Component',
  'pages.dataImport.record.coefficient': 'Coefficient',
  'pages.dataImport.record.getDetailFailed': 'Failed to get details',
  'pages.dataImport.record.missingParams': 'Missing required parameters',
  'pages.dataImport.record.batchInfo': 'Batch Information',
  'pages.dataImport.record.batchNo': 'Batch No',
  'pages.dataImport.record.reportFile': 'Report File',
  'pages.dataImport.record.approvalName': 'Approver',
  'pages.dataImport.record.baseData': 'Basic Data',
  'pages.dataImport.record.meltingPoint': 'Melting Point',
  'pages.dataImport.record.boilingPoint': 'Boiling Point',
  'pages.dataImport.record.meltingEnthalpy': 'Melting Enthalpy',
  'pages.dataImport.record.surfaceTension': 'Surface Tension',
  'pages.dataImport.record.contactAngle': 'Contact Angle',
  'pages.dataImport.record.thermalWeightLoss': 'Thermal Weight Loss',
  'pages.dataImport.record.vaporPressure': 'Vapor Pressure',
  'pages.dataImport.record.chemicalData': 'Chemical Data',
  'pages.dataImport.record.corrosive': 'Corrosivity',
  'pages.dataImport.record.corrosionPotential': 'Corrosion Potential',
  'pages.dataImport.record.thermalStabilityWindow': 'Thermal Stability Window',
  'pages.dataImport.record.thermalStabilityWidth': 'Thermal Stability Width',
  'pages.dataImport.record.electrochemistryWindow': 'Electrochemical Window',
  'pages.dataImport.record.testData': 'Test Data',
  'pages.dataImport.record.sampleSize': 'Sample Size',
  'pages.dataImport.record.testTime': 'Test Time',
  'pages.dataImport.record.testPerson': 'Tester',
  'pages.dataImport.record.testingAgency': 'Testing Agency',
  'pages.dataImport.record.atmosphere': 'Atmosphere',
  'pages.dataImport.record.impurityConcentration': 'Impurity Concentration',
  'pages.dataImport.record.boxSize': 'Simulation Box Size',
  'pages.dataImport.record.boxStepLength': 'Simulation Box Step Length',
  'pages.dataImport.record.potentialFunc': 'Potential Function Type',
  'pages.dataImport.record.simulationAlgorithm': 'Simulation Algorithm',
  'pages.dataImport.record.simulationData': 'Simulation Data',
  // Third Import Nist
  'pages.nist.system': 'System',
  'pages.nist.physicalPropType': 'Physical Property Type',
  'pages.nist.all': 'All',
  'pages.nist.externalDataInfo': 'External Data Information',
  'pages.nist.dataSource': 'Data Source',
  'pages.nist.database': 'NIST Database',
  'pages.nist.physicalUnit': 'Physical Unit',
  'pages.nist.index': 'Index',
  'pages.nist.component': 'Component',
  'pages.nist.coefficient': 'Coefficient',
  'pages.nist.tempUnit': 'Temperature Unit',
  'pages.nist.dataType': 'Data Type',
  'pages.nist.moreActions': 'More Actions',
  'pages.nist.detail': 'Detail',
  'pages.nist.externalDataDetail': 'External Data Detail',
  'pages.nist.confirm': 'Confirm',
  'pages.nist.comment': 'Comment',
  'pages.nist.formatComment': 'Format Comment',
  'pages.nist.syncTime': 'Sync Time',
  // Third Import MatWeb
  'pages.matweb.keyword': 'Wildcard Keyword',
  'pages.matweb.index': 'Index',
  'pages.matweb.casNumber': 'CAS Number',
  'pages.matweb.materialName': 'Material Name',
  'pages.matweb.keywords': 'Material Keywords',
  'pages.matweb.meltingPoint': 'Melting Point',
  'pages.matweb.boilingPoint': 'Boiling Point',
  'pages.matweb.density': 'Density',
  'pages.matweb.specificHeatCapacity': 'Specific Heat Capacity',
  'pages.matweb.importTime': 'Data Import Time',
  'pages.matweb.moreActions': 'More Actions',
  'pages.matweb.detail': 'Detail',
  'pages.matweb.edit': 'Edit Data',
  'pages.matweb.database': 'MatWeb Database',
  // Data Upload Add missing
  'pages.dataUpload.add.physicalType': 'Physical Type',
  'pages.dataUpload.add.pleaseSelectPhysicalTypeFirst': 'Please select physical type first',
  'pages.dataUpload.add.tempUnit': 'Temperature Unit',
  'pages.dataUpload.add.docData': 'Document Data',
  // Monitor System Overview
  'pages.monitor.systemOverview.title': 'System Overview',
  'pages.monitor.systemOverview.totalServices': 'Total Services',
  'pages.monitor.systemOverview.runningServices': 'Running',
  'pages.monitor.systemOverview.memoryUsage': 'Memory Usage',
  'pages.monitor.systemOverview.cpuUsage': 'CPU Usage',
  'pages.monitor.systemOverview.diskUsage': 'Disk Usage',
  'pages.monitor.systemOverview.noChange': 'No Change',
  'pages.monitor.systemOverview.cpuUsageRate': 'CPU Usage Rate',
  'pages.monitor.systemOverview.memoryUsageRate': 'Memory Usage Rate',
  'pages.monitor.systemOverview.diskUsageRate': 'Disk Usage Rate',
  'pages.monitor.systemOverview.noData': 'No Data',
  'pages.monitor.systemOverview.microserviceStatus': 'Service Status',
  'pages.monitor.systemOverview.unknownService': 'Unknown Service',
  'pages.monitor.systemOverview.running': 'Running',
  'pages.monitor.systemOverview.stopped': 'Stopped',
  'pages.monitor.systemOverview.error': 'Error',
  'pages.monitor.systemOverview.unknown': 'Unknown',
  'pages.monitor.systemOverview.port': 'Port',
  'pages.monitor.systemOverview.responseTime': 'Response Time',
  'pages.monitor.systemOverview.activeCount': 'Active Count',
  'pages.monitor.systemOverview.metricValue': 'Metric Value',
  'pages.monitor.systemOverview.noServiceData': 'No Service Data',
  'pages.monitor.systemOverview.fetchFailed': 'Failed to fetch system overview',
  'pages.monitor.systemOverview.fetchFailedRetry': 'Failed to fetch system overview, please try again later',
  'pages.monitor.systemOverview.cpuUsageRateTooltip': 'CPU Usage Rate',
  'pages.monitor.systemOverview.memoryUsageRateTooltip': 'Memory Usage Rate',
  'pages.monitor.systemOverview.diskUsageRateTooltip': 'Disk Usage Rate',
  // Monitor Log Management
  'pages.monitor.logManagement.title': 'Log Management',
  'pages.monitor.logManagement.selectMicroservice': 'Select Microservice',
  'pages.monitor.logManagement.refresh': 'Refresh',
  'pages.monitor.logManagement.clear': 'Clear',
  'pages.monitor.logManagement.noAvailableServices': 'No Available Services',
  'pages.monitor.logManagement.realtimeLogs': 'Realtime Logs',
  'pages.monitor.logManagement.historyLogs': 'History Logs',
  'pages.monitor.logManagement.noLogData': 'No Log Data',
  'pages.monitor.logManagement.download': 'Download',
  'pages.monitor.logManagement.modifiedTime': 'Modified Time',
  'pages.monitor.logManagement.total': 'Total',
  'pages.monitor.logManagement.items': 'items',
  'pages.monitor.logManagement.noHistoryLogFiles': 'No History Log Files',
  'pages.monitor.logManagement.selectServiceFirst': 'Please select a service first',
  'pages.monitor.logManagement.fetchServicesFailed': 'Failed to fetch service list',
  'pages.monitor.logManagement.fetchServicesFailedRetry': 'Failed to fetch service list, please try again later',
  'pages.monitor.logManagement.fetchRealtimeLogsFailed': 'Failed to fetch realtime logs',
  'pages.monitor.logManagement.fetchRealtimeLogsFailedRetry': 'Failed to fetch realtime logs, please try again later',
  'pages.monitor.logManagement.fetchHistoryLogsFailed': 'Failed to fetch history logs',
  'pages.monitor.logManagement.fetchHistoryLogsFailedRetry': 'Failed to fetch history logs, please try again later',
  'pages.monitor.logManagement.downloadStarted': 'Log file download started',
  'pages.monitor.logManagement.downloadFailed': 'Failed to download log file',
  'pages.monitor.logManagement.downloadFailedRetry': 'Failed to download log file, please try again later',
  'pages.monitor.logManagement.logsCleared': 'Logs cleared',
}
